{
  "common": {
    "main": {
      "project": "Proyecto",
      "form": "Formulario",
      "version": "Versión",
      "formSettings": "Configuración de formulario",
      "user": "Usuario",
      "organization": "Organización",
      "server": "Servidor",
      "url": "URL"
    },
    "buttons": {
      "ok": "Aceptar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "add": "Agregar",
      "edit": "Editar",
      "delete": "Eliminar",
      "refresh": "Actualizar",
      "create": "Crear",
      "submit": "Enviar",
      "clear": "Limpiar",
      "selectAll": "Seleccionar todo",
      "back": "Atrás",
      "next": "Siguiente",
      "previous": "Anterior",
      "close": "Cerrar",
      "confirm": "Confirmar",
      "yes": "Sí",
      "no": "No",
      "search": "Buscar",
      "filter": "Filtrar",
      "export": "Exportar",
      "import": "Importar",
      "download": "Descargar",
      "upload": "Subir",
      "view": "Ver",
      "preview": "Vista previa",
      "copy": "Copiar",
      "assign": "Asignar",
      "unassign": "Desvincular",
      "retry": "Reintentar",
      "loading": "Cargando..."
    },
    "dialogs": {
      "cancel": "Cancelar",
      "close": "Cerrar",
      "confirm": "Confirmar",
      "delete": "Eliminar",
      "save": "Guardar cambios",
      "confirmTitle": "Confirmar acción",
      "unsavedChanges": {
        "title": "Cambios sin guardar",
        "message": "Hay cambios sin guardar. ¿Cerrar sin guardar?"
      }
    },
    "table": {
      "headers": {
        "name": "Nombre",
        "description": "Descripción",
        "statistics": "Estadísticas",
        "status": "Estado",
        "actions": "Acciones",
        "createdAt": "Fecha de creación",
        "updatedAt": "Fecha de actualización",
        "created": "Creado",
        "updated": "Actualizado",
        "type": "Tipo",
        "version": "Versión",
        "id": "ID",
        "email": "Correo electrónico",
        "role": "Rol",
        "user": "Usuario",
        "project": "Proyecto",
        "organization": "Organización",
        "lastSubmission": "Última presentación",
        "server": "Servidor",
        "url": "URL",
        "format": "Formato",
        "count": "Cantidad",
        "size": "Tamaño",
        "date": "Fecha",
        "time": "Hora",
        "severity": "Severidad",
        "field": "Campo Principal",
        "form": "Formulario",
        "state": "Estado",
        "roles": "Roles",
        "groups": "Grupos",
        "formId": "ID del formulario",
        "permissions": "Permisos",
        "enabled": "Habilitado",
        "disabled": "Deshabilitado",
        "submissions": "Presentaciones",
        "publishedAt": "Publicado el"
      },
      "pagination": {
        "page": "Página",
        "of": "de",
        "perPage": "por página",
        "showing": "Mostrando",
        "to": "a",
        "totalEntries": "entradas totales",
        "resultsText": "resultados.",
        "perPageText": "Resultados por página"
      },
      "ariaLabels": {
        "viewDetails": "Ver detalles",
        "edit": "Editar",
        "delete": "Eliminar",
        "previousPage": "Página anterior",
        "nextPage": "Página siguiente"
      }
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo",
      "archived": "Archivado",
      "draft": "Borrador",
      "published": "Publicado",
      "pending": "Pendiente",
      "completed": "Completado",
      "failed": "Fallido",
      "success": "Éxito",
      "error": "Error",
      "warning": "Advertencia",
      "info": "Información",
      "loading": "Cargando",
      "notSet": "No establecido",
      "notSpecified": "No especificado",
      "notAvailable": "N/A",
      "unknown": "Desconocido",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado"
    },
    "messages": {
      "confirmDelete": "¿Estás seguro de que quieres eliminar",
      "confirmDeleteWithName": "¿Estás seguro de que quieres eliminar \"{name}\"?",
      "deleteSuccess": "Eliminado exitosamente",
      "deleteError": "Error al eliminar",
      "saveSuccess": "Guardado exitosamente",
      "saveError": "Error al guardar",
      "createSuccess": "Creado exitosamente",
      "createError": "Error al crear",
      "updateSuccess": "Actualizado exitosamente",
      "updateError": "Error al actualizar",
      "error": "Error",
      "loadError": "Error al cargar",
      "noData": "Sin datos",
      "noResults": "Sin resultados",
      "required": "Este campo es obligatorio",
      "invalidEmail": "Por favor ingresa un correo electrónico válido",
      "confirmDeleteWithType": "¿Estás seguro de que quieres eliminar \"{name}\" ({type})?",
      "bulkOperationSuccess": "Operación masiva completada exitosamente",
      "bulkOperationError": "Error al realizar operación masiva",
      "operationFailed": "No se pudo realizar la operación",
      "unsavedChanges": "El formulario contiene cambios sin guardar. ¿Está seguro de que desea cerrarlo?",
      "created": "creado",
      "updated": "actualizado",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Estadísticas",
      "subtitle": "Revise las métricas a nivel organizacional, los estados de los formularios y la actividad de los proyectos.",
      "overall": "Estadísticas Generales",
      "byState": "Formularios por Estado",
      "projectDetails": "Detalles del Proyecto",
      "projectLedger": "Registro de proyectos",
      "pipeline": "Estado",
      "projectCount": "{count} proyectos",
      "noActiveForms": "No hay formularios activos",
      "projects": "Proyectos",
      "totalForms": "Total de Formularios",
      "activeForms": "Formularios Activos",
      "submissions": "Envíos",
      "forms": "Formularios",
      "lastUpdated": "Última actualización",
      "noDataToDisplay": "No hay datos para mostrar"
    },
    "viewMode": {
      "cards": "Tarjetas",
      "table": "Tabla",
      "list": "Lista",
      "grid": "Cuadrícula"
    },
    "time": {
      "today": "hoy",
      "yesterday": "ayer",
      "thisWeek": "esta semana",
      "lastWeek": "la semana pasada",
      "thisMonth": "este mes",
      "lastMonth": "el mes pasado",
      "allTime": "todo el tiempo",
      "last7Days": "Últimos 7 días",
      "last30Days": "Últimos 30 días",
      "last90Days": "Últimos 90 días",
      "customRange": "Rango personalizado",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de fin",
      "justNow": "Justo ahora",
      "minutesAgo": "hace {count} min",
      "hoursAgo": "hace {count} h",
      "daysAgo": "hace {count} días",
      "never": "Nunca"
    },
    "placeholders": {
      "enterName": "Ingresar nombre",
      "enterDescription": "Ingresar descripción",
      "enterEmail": "Ingresar correo electrónico",
      "enterUrl": "Ingresar URL",
      "search": "Buscar...",
      "selectOption": "Seleccionar opción"
    },
    "formState": {
      "title": "Cambiar Estado del Formulario",
      "form": "Formulario",
      "currentStatus": "Estado actual",
      "newStatus": "Nuevo estado",
      "pleaseSelectStatus": "Por favor selecciona un estado",
      "statusChangedSuccessfully": "Estado del formulario {formName} cambiado exitosamente a {status}",
      "errorChangingStatus": "Error al cambiar el estado del formulario"
    }
  },
  "admin": {
    "agent": {
      "title": "Agente Hermes",
      "subtitle": "Monitorear y gestionar la integración del agente AI",
      "back": "Volver al dashboard",
      "health": {
        "title": "Integración de salud",
        "checkNow": "Verificar ahora",
        "latency": "Latencia",
        "lastCheck": "Última comprobación"
      },
      "stats": {
        "activeSubs": "Suscripciones activas",
        "requestsToday": "Solicitudes hoy",
        "tokensToday": "Tokens hoy",
        "nearQuota": "Orgs cerca de cuota",
        "activeSubsHint": "{total} en total",
        "nearQuotaHint": ">80% usado"
      },
      "config": {
        "title": "Configuración (solo lectura)"
      },
      "jobs": {
        "title": "RQ Jobs (reportes analíticos)",
        "empty": "No hay trabajos recientes"
      },
      "digests": {
        "title": "Digests proactivos",
        "trigger": "Disparar manualmente",
        "historyTitle": "Historial de digests",
        "historyEmpty": "No se han registrado ejecuciones de digests aún."
      },
      "selfHeal": {
        "title": "Jobs de auto-curación",
        "trigger": "Ejecutar ahora"
      },
      "incident": {
        "banner": "Hermes o MCP no están disponibles. Las características del agente pueden estar degradadas.",
        "title": "Requiere atención"
      },
      "subscriptions": {
        "title": "Suscripciones del agente",
        "subtitle": "Gestionar niveles, cuotas y características por organización",
        "searchPlaceholder": "Buscar organización...",
        "allTiers": "Todos los niveles",
        "editTitle": "Editar suscripción",
        "resetTitle": "Restablecer uso",
        "resetMessage": "Restablecer contadores de uso para {name}?",
        "resetConfirm": "Restablecer",
        "empty": "No se encontraron suscripciones",
        "tierDefaultsTitle": "Niveles predeterminados",
        "tierDefaultsHint": "Referencia de límites desde backend SSOT. Cambiar nivel en el formulario de edición aplica estos valores (sobrescritos aún posibles).",
        "columns": {
          "org": "Organización",
          "tier": "Nivel",
          "fiveHour": "5h",
          "week": "Semana",
          "month": "Mes",
          "features": "Características"
        },
        "tierDefaults": {
          "fiveHour": "5h (req / tok)",
          "week": "Semana (req / tok)",
          "month": "Mes (req / tok)"
        }
      },
      "usage": {
        "title": "Uso del agente",
        "subtitle": "Registro de invocaciones en todas las organizaciones",
        "orgIdPlaceholder": "Org ID",
        "allFeatures": "Todas las características",
        "empty": "No se encontraron eventos de uso",
        "columns": {
          "time": "Tiempo",
          "org": "Organización",
          "user": "Usuario",
          "feature": "Característica",
          "tokens": "Tokens"
        }
      },
      "audit": {
        "title": "Auditoría de tool-calls",
        "subtitle": "Registro de invocaciones de herramientas MCP (especialmente acciones de escritura)",
        "orgIdPlaceholder": "Org ID",
        "toolPlaceholder": "Nombre de la herramienta",
        "writeOnly": "Escribir herramientas solo",
        "detailTitle": "Detalle de auditoría",
        "detail": "Detalle",
        "empty": "No se encontraron registros de auditoría",
        "write": "Escribir",
        "read": "Leer",
        "columns": {
          "time": "Tiempo",
          "org": "Organización",
          "tool": "Herramienta",
          "write": "Escribir"
        }
      },
      "sections": {
        "metrics": "Pulso"
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Eliminar proyecto",
        "message": "Esta acción no se puede deshacer. Se eliminarán todas las formas vinculadas.",
        "formsCount": "Formas a eliminar: {count}",
        "confirm": "Eliminar permanentemente"
      },
      "deleteOrganization": {
        "title": "Eliminar organización",
        "message": "Esta acción no se puede deshacer. Se verán afectados todos los proyectos y usuarios.",
        "confirm": "Eliminar permanentemente"
      },
      "deleteForm": {
        "title": "Eliminar forma",
        "message": "Esta acción no se puede deshacer.",
        "confirm": "Eliminar permanentemente"
      },
      "deleteUser": {
        "title": "Eliminar usuario",
        "message": "Esta acción no se puede deshacer. El usuario perderá acceso a todas las organizaciones.",
        "confirm": "Eliminar permanentemente"
      },
      "projectDetails": "Proyecto: {name}",
      "organizationDetails": "Organización: {name}",
      "formDetails": "Forma: {name}",
      "userDetails": "Usuario: {name}",
      "close": "Cerrar",
      "createUser": {
        "title": "Crear usuario"
      },
      "editUser": {
        "title": "Editar usuario"
      },
      "fullName": "Nombre completo",
      "superuser": "Superusuario",
      "active": "Activo"
    },
    "back": "Volver al dashboard",
    "chrome": {
      "sessionLabel": "Superusuario · todas las acciones registradas",
      "exit": "Modo de salida",
      "menuTitle": "Administración",
      "sessionWarning": "La sesión de administrador expira en {time}.",
      "extendSession": "Extender sesión"
    },
    "nav": {
      "groups": {
        "overview": "Vista general",
        "directory": "Directorio",
        "access": "Acceso",
        "integrations": "Integraciones",
        "platform": "Plataforma"
      },
      "dashboard": "Panel",
      "analytics": "Analítica",
      "users": "Usuarios",
      "organizations": "Organizaciones",
      "projects": "Proyectos",
      "forms": "Formularios",
      "roles": "Roles & permisos",
      "permissionGroups": "Grupos de permisos",
      "agent": "Hermes Agent",
      "agentDashboard": "Dashboard del agente",
      "agentSubscriptions": "Suscripciones del agente",
      "agentUsage": "Uso del agente",
      "agentAudit": "Auditoría del agente",
      "globalOdk": "Servidores ODK globales",
      "system": "Sistema",
      "audit": "Auditoría",
      "subscriptions": "Facturación"
    },
    "pagination": {
      "shown": "Mostrando {start} - {end} de {total}",
      "pageOf": "Página {page} de {pages}",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "common": {
      "tryAgain": "Intentar nuevamente",
      "showDeleted": "Mostrar eliminados",
      "hideDeleted": "Ocultar eliminados",
      "showArchived": "Mostrar archivados",
      "hideArchived": "Ocultar archivados",
      "allOrganizations": "Todas las organizaciones",
      "allProjects": "Todos los proyectos",
      "allRoles": "Todos los roles",
      "allStatuses": "Todos los estados",
      "totalRecords": "Total de registros: {count}",
      "orgIdPrefix": "Org #{id}",
      "projectIdPrefix": "Project #{id}",
      "notSet": "No establecido",
      "health": {
        "healthy": "Saludable",
        "degraded": "Degradado",
        "disabled": "Deshabilitado",
        "unhealthy": "No saludable",
        "unknown": "Desconocido"
      }
    },
    "pages": {
      "users": {
        "title": "Gestión de usuarios",
        "subtitle": "Ver y gestionar todos los usuarios del sistema",
        "addUser": "Agregar usuario",
        "searchPlaceholder": "Buscar usuarios...",
        "superuserBadge": "Superusuario",
        "userBadge": "Usuario",
        "statsTotal": "Total",
        "statsSuperusers": "Superusuarios",
        "statsOwners": "Propietarios",
        "statsActive": "Activo",
        "loadError": "No se pudieron cargar los usuarios",
        "empty": "No se encontraron usuarios que coincidan con los filtros actuales"
      },
      "organizations": {
        "title": "Gestión de organizaciones",
        "subtitle": "Ver y gestionar todas las organizaciones del sistema",
        "searchPlaceholder": "Buscar por nombre o descripción de la organización...",
        "sectionTitle": "Organizaciones",
        "loading": "Cargando organizaciones...",
        "empty": "No se encontraron organizaciones",
        "loadError": "No se pudieron cargar las organizaciones",
        "restored": "Organización restaurada",
        "restoreError": "No se pudo restaurar la organización",
        "owner": "Propietario",
        "created": "Creado",
        "deletedBadge": "Eliminado",
        "activeBadge": "Activo",
        "agentSubscription": "Suscripción del agente",
        "statsTotal": "Total de organizaciones",
        "statsActive": "Activo",
        "statsProjects": "Proyectos",
        "statsForms": "Formularios"
      },
      "projects": {
        "title": "Gestión de proyectos",
        "subtitle": "Ver y gestionar todos los proyectos del sistema",
        "searchPlaceholder": "Buscar por nombre o descripción del proyecto...",
        "sectionTitle": "Proyectos",
        "loading": "Cargando proyectos...",
        "empty": "No se encontraron proyectos",
        "loadError": "No se pudieron cargar los proyectos",
        "archived": "Proyecto archivado",
        "unarchived": "Proyecto desarchivado",
        "archiveError": "No se pudo archivar el proyecto",
        "unarchiveError": "No se pudo desarchivar el proyecto",
        "created": "Creado",
        "archivedBadge": "Archivado",
        "activeBadge": "Activo",
        "statsTotal": "Total de proyectos",
        "statsActive": "Activo",
        "statsArchived": "Archivado",
        "statsForms": "Formularios"
      },
      "forms": {
        "title": "Gestión de formularios",
        "subtitle": "Ver y gestionar todos los formularios del sistema",
        "searchPlaceholder": "Buscar por nombre o ID XML del formulario...",
        "sectionTitle": "Formularios",
        "loading": "Cargando formularios...",
        "empty": "No se encontraron formularios",
        "loadError": "No se pudieron cargar los formularios",
        "deletedToast": "Formulario marcado como eliminado",
        "restoredToast": "Formulario restaurado",
        "deleteError": "No se pudo eliminar el formulario",
        "restoreError": "No se pudo restaurar el formulario",
        "created": "Creado",
        "deletedBadge": "Eliminado",
        "activeBadge": "Activo",
        "importedBadge": "Importado",
        "statsTotal": "Total de formularios",
        "statsActive": "Activo",
        "statsDeleted": "Eliminado",
        "statsImported": "Importado"
      },
      "permissionGroups": {
        "title": "Grupos de permisos",
        "subtitle": "Gestionar grupos de permisos y asignarlos a usuarios",
        "createGroup": "Crear grupo",
        "sectionTitle": "Grupos de permisos",
        "searchPlaceholder": "Buscar grupos...",
        "emptyFilter": "No se encontraron grupos que coincidan con la búsqueda actual",
        "restoreError": "No se pudo restaurar el grupo de permisos",
        "deleteError": "No se pudo eliminar el grupo de permisos",
        "emptyTitle": "No se encontraron grupos de permisos",
        "emptyBody": "Crea el primer grupo de permisos para empezar",
        "deleteTitle": "Eliminar grupo",
        "deleteMessage": "¿Estás seguro de querer eliminar el grupo \"{name}\"? Esta acción no se puede deshacer.",
        "restoreTitle": "Restaurar",
        "users": "Usuarios",
        "statsTotal": "Total de grupos",
        "statsActive": "Grupos activos",
        "statsAssignments": "Asignaciones",
        "loadError": "No se pudieron cargar los grupos de permisos",
        "restored": "Grupo \"{name}\" restaurado",
        "deleted": "Grupo de permisos eliminado",
        "saved": "Grupo de permisos guardado",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Servidores ODK globales",
        "subtitle": "Crear y gestionar servidores ODK globales",
        "createServer": "Crear servidor",
        "statsTotal": "Total de servidores",
        "statsTotalHint": "{count} (+{active} activos)",
        "statsGlobal": "Globales",
        "statsDefault": "Predeterminado",
        "testTitle": "Resultado de la prueba de conexión",
        "testOk": "Conexión exitosa",
        "testFail": "Conexión fallida",
        "testMethod": "Método:",
        "testProjects": "Total de proyectos:",
        "testing": "Probando conexión...",
        "refreshTokenTitle": "Actualizar token API",
        "refreshTokenBody": "Ingrese la contraseña para actualizar el token API para el servidor",
        "password": "Contraseña",
        "passwordPlaceholder": "Ingrese la contraseña",
        "refreshTokenAction": "Actualizar token",
        "requiredField": "Este campo es requerido",
        "searchPlaceholder": "Buscar por nombre, URL o nombre de usuario...",
        "empty": "No se encontraron servidores ODK globales",
        "emptyHint": "Crea el primer servidor ODK global para empezar.",
        "emptyFilter": "No se encontraron servidores que coincidan con la búsqueda actual",
        "defaultBadge": "Predeterminado",
        "columns": {
          "server": "Servidor",
          "user": "Usuario",
          "visibility": "Visibilidad"
        },
        "visibility": {
          "GLOBAL": "Global",
          "ORGANIZATION": "Organización",
          "SHARED": "Compartido"
        },
        "actions": {
          "test": "Probar conexión",
          "refreshToken": "Actualizar token",
          "setDefault": "Establecer como predeterminado"
        },
        "deleteTitle": "Eliminar servidor",
        "deleteMessage": "¿Eliminar el servidor \"{name}\"? Esta acción no se puede deshacer.",
        "setDefaultTitle": "Establecer servidor predeterminado",
        "setDefaultMessage": "¿Establecer \"{name}\" como el servidor ODK global predeterminado?",
        "setDefaultConfirm": "Establecer",
        "toastCreated": "Servidor creado",
        "toastUpdated": "Servidor actualizado",
        "toastDeleted": "Servidor eliminado",
        "toastTestOk": "Conexión exitosa",
        "toastTokenRefreshed": "Token API actualizado",
        "toastDefaultSet": "Servidor global predeterminado actualizado",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Suscripciones de facturación",
        "subtitle": "Facturación SaaS y planes de pago (no cuotas de Hermes Agent)",
        "stubBadge": "Próximamente",
        "stubBody": "Las suscripciones de facturación y pago están en desarrollo. Esta página gestionará los planes comerciales cuando se lance la facturación.",
        "stubAgentHint": "Los niveles, cuotas y banderas de características de Hermes Agent se gestionan en Integraciones → Hermes Agent → Suscripciones.",
        "openAgentSubscriptions": "Abrir suscripciones del agente"
      },
      "audit": {
        "title": "Auditoría de acciones",
        "subtitle": "Registro de acciones administrativas de superusuarios",
        "loadError": "No se pudo cargar el registro de auditoría.",
        "empty": "Aún no hay registros de auditoría",
        "time": "Tiempo",
        "user": "Usuario",
        "action": "Acción",
        "details": "Detalles",
        "emptyFilter": "Ningún registro coincide con la búsqueda actual",
        "searchPlaceholder": "Buscar por usuario, acción o detalles...",
        "actionKey": "Clave de acción",
        "detailTitle": "Entrada de auditoría"
      },
      "system": {
        "title": "Salud del sistema",
        "subtitle": "Diagnósticos de infraestructura: estado, latencia y detalles de tiempo de ejecución",
        "loadError": "No se pudo cargar el estado del sistema.",
        "serverInfo": "Detalles de ejecución",
        "version": "Versión",
        "uptime": "Tiempo de actividad del proceso",
        "dbConnections": "Conexiones a BD (activas)",
        "dbPool": "Tamaño del grupo de BD",
        "components": {
          "server": "Servidor",
          "database": "Base de datos",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        },
        "attentionTitle": "Requiere atención",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Abrir agente",
        "componentsTitle": "Componentes",
        "dbLatency": "Latencia de BD",
        "apiLatency": "Latencia de API"
      },
      "analytics": {
        "title": "Panel de analíticas",
        "subtitle": "Analíticas del sistema y de usuarios",
        "loadError": "No se pudieron cargar las analíticas. Mostrando valores cero.",
        "totalUsers": "Total de usuarios",
        "thisMonth": "+{count} este mes",
        "organizations": "Organizaciones",
        "growthPct": "{pct}% de crecimiento",
        "totalProjects": "Total de proyectos",
        "totalForms": "Total de formularios",
        "submissions": "Envíos",
        "userGrowth": "Crecimiento de usuarios (por mes)",
        "orgActivity": "Actividad de organizaciones (por proyectos)",
        "noData": "Sin datos",
        "topOrgs": "Principales organizaciones",
        "projectsCount": "{count} proyectos",
        "noOrgs": "Sin organizaciones",
        "recentActivity": "Actividad reciente",
        "noRecent": "Sin actividad reciente",
        "systemHealth": "Salud del sistema",
        "resources": "Uso de recursos",
        "orgs": "Organizaciones",
        "projects": "Proyectos",
        "forms": "Formularios",
        "health": {
          "api": "API",
          "database": "Base de datos",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Roles y permisos",
        "subtitle": "Catálogo de roles de la plataforma — bloques para grupos de permisos",
        "searchPlaceholder": "Buscar roles...",
        "loadError": "No se pudieron cargar los roles.",
        "emptyTitle": "No se encontraron roles",
        "emptyFilter": "Ningún rol coincide con la búsqueda",
        "openGroups": "Grupos de permisos",
        "system": "Sistema",
        "custom": "Personalizado",
        "unused": "No usado en ningún grupo",
        "columns": {
          "role": "Rol",
          "description": "Descripción",
          "usedIn": "Usado en grupos",
          "type": "Tipo"
        },
        "labels": {
          "project_member": "Miembro del proyecto"
        },
        "descriptions": {
          "fallback": "No hay descripción disponible.",
          "manager": "Gestión completa del proyecto y supervisión de calidad.",
          "project_member": "Acceso mínimo al proyecto — nombre y formularios, sin datos de envíos.",
          "data_viewer": "Acceso de solo lectura a envíos, monitoreo y revisión QC.",
          "data_collector": "Recopilar y enviar datos de campo.",
          "data_downloader": "Exportar y descargar datos de envíos.",
          "data_analyst": "Operaciones QC y análisis de datos.",
          "form_designer": "Crear y gestionar formularios XLSForm.",
          "qc_editor": "Editar resultados y hallazgos QC."
        }
      }
    },
    "dashboard": {
      "title": "Vista general",
      "subtitle": "Estado de la plataforma y actividad reciente del administrador",
      "errors": {
        "stats": "No se pudieron cargar las métricas del sistema. Mostrando ceros.",
        "health": "No se pudo cargar el estado del sistema.",
        "activities": "No se pudo cargar la actividad reciente."
      },
      "attention": {
        "title": "Requiere atención",
        "server": "El servidor reporta un estado no saludable.",
        "database": "La base de datos reporta un estado no saludable.",
        "redis": "Redis reporta un estado no saludable.",
        "api": "La API reporta un estado no saludable.",
        "agent": "Estado de Hermes Agent: {status}.",
        "failedLogins": "{count} intentos de inicio de sesión fallidos en las últimas 24 horas.",
        "openSystem": "Abrir sistema",
        "openAgent": "Abrir agente",
        "openAudit": "Abrir auditoría"
      },
      "sections": {
        "metrics": "Directorio",
        "health": "Estado",
        "activity": "Actividad reciente"
      },
      "metrics": {
        "users": "Usuarios",
        "usersHint": "+{count} hoy",
        "orgs": "Organizaciones",
        "orgsHint": "+{count} esta semana",
        "projects": "Proyectos",
        "projectsHint": "{count} activos",
        "failedLogins": "Inicios de sesión fallidos",
        "failedLoginsHint": "Últimas 24 horas"
      },
      "health": {
        "server": "Servidor",
        "database": "Base de datos",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} conexiones",
        "latency": "{ms} ms",
        "agentHint": "{count} sol. hoy"
      },
      "activity": {
        "viewAll": "Ver auditoría",
        "empty": "No hay actividad reciente del administrador"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Cargando suscripción del agente...",
      "working": "El agente está trabajando..."
    },
    "features": {
      "reports": "Reportes",
      "qc": "Asistente QC",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Error al llamar al agente.",
      "endpointNotFound": "Esta característica no está disponible en el backend en ejecución. Reinicie el servidor de desarrollo del backend (.\\scripts\\dev.ps1).",
      "timeout": "El agente no respondió en tiempo. El asistente XLSForm puede tomar hasta 10 minutos — inténtalo de nuevo.",
      "featureUnavailable": "Esta característica no está disponible en su plan.",
      "quotaExceeded": "Quota del agente excedida para este período.",
      "disabled": "El agente AI está temporalmente deshabilitado.",
      "mcpUnavailable": "Hermes no puede ver las herramientas MCP de udacapi. Registre MCP en CT253 (grant-udacapi-mcp.sh) y verifique el relay :8101 → backend :8100. Ver runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Límite mensual de solicitudes alcanzado",
          "tokens": "Límite mensual de tokens alcanzado"
        },
        "five_hour": {
          "requests": "Límite de solicitudes de 5 horas alcanzado",
          "tokens": "Límite de tokens de 5 horas alcanzado"
        },
        "weekly": {
          "requests": "Límite semanal de solicitudes alcanzado",
          "tokens": "Límite semanal de tokens alcanzado"
        }
      },
      "usageLine": "{used} de {limit} usados",
      "resetsAt": "Disponible de nuevo {relative} ({absolute})",
      "resetsUnknown": "Inténtelo más tarde o contacte a su administrador para aumentar los límites.",
      "viewSubscription": "Ver detalles de cuota",
      "sendBlocked": "Cuota del agente agotada — espere a que se reinicie el límite.",
      "nearLimit": "Cuota del agente casi agotada ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Característica bloqueada",
      "lockedDescription": "\"{feature}\" está disponible en el plan {tier} y superior."
    },
    "subscription": {
      "sectionTitle": "Agente AI",
      "sectionDescription": "El nivel de agente de su organización, cuotas y características habilitadas.",
      "currentTier": "Nivel actual",
      "active": "Activo",
      "inactive": "Inactivo",
      "features": "Características habilitadas",
      "tier": "Nivel",
      "capabilities": "Capacidades",
      "billingPeriod": "Inicio del período de facturación",
      "requests": "Solicitudes en este período",
      "requests_5h": "Solicitudes (últimas 5h)",
      "requests_weekly": "Solicitudes (última semana)",
      "requests_badge": "sol.",
      "requests_5h_badge": "sol. (5h)",
      "requests_weekly_badge": "soll. (sem.)",
      "tokens": "tokens en este período",
      "tokens_5h": "tokens (últimas 5h)",
      "tokens_weekly": "tokens (última semana)",
      "nearQuotaTitle": "Límite de cuota cercano",
      "nearQuotaDescription": "Más del 80% de la cuota mensual se está usando. Contacte a su administrador para aumentar los límites.",
      "tiers": {
        "free": "Gratis",
        "pro": "Pro",
        "enterprise": "Enterprise"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "Reporte AI para PM",
      "description": "Resumen de submisiones preparado por el agente AI de UDA.",
      "period": "Periodo (días)",
      "generate": "Generar reporte",
      "generating": "El agente está preparando el reporte...",
      "empty": "Haga clic en \"Generar reporte\" para obtener un resumen.",
      "modeSummary": "Resumen",
      "modeAnalytical": "Analítico",
      "modeScheduled": "Por plantilla",
      "quotaExceeded": "Quota del agente excedida para este período.",
      "featureUnavailable": "Reportes AI no están disponibles en su plan.",
      "error": "Error al obtener el reporte del agente.",
      "healthAlerts": "Notas de salud del formulario",
      "copy": "Copiar reporte",
      "copied": "Copiado",
      "copyFailed": "No se pudo copiar al portapapeles.",
      "viewFormatted": "Formato",
      "viewRaw": "Markdown",
      "auto": {
        "latest": "Último",
        "history": "Historial",
        "generateNow": "Generar ahora",
        "manageTemplates": "Gestionar plantillas",
        "selectTemplate": "Plantilla",
        "latestEmpty": "No hay informes de plantilla completados aún. Elige una plantilla y haz clic en Generar ahora.",
        "historyEmpty": "No hay ejecuciones de informes aún.",
        "view": "Ver",
        "viewTitle": "Informe",
        "close": "Cerrar",
        "generating": "Generando informe programado...",
        "done": "Informe listo.",
        "statusLabel": "Estado: {status}",
        "emptyResult": "El informe se completó pero no devolvió contenido.",
        "runFailed": "La generación del informe falló.",
        "timeout": "El informe tardó demasiado. Inténtalo de nuevo más tarde.",
        "noContent": "No hay contenido de informe disponible.",
        "unknownTemplate": "Plantilla desconocida",
        "trigger": {
          "scheduled": "Programado",
          "event": "Evento",
          "manual": "Manual"
        },
        "status": {
          "pending": "Pendiente",
          "running": "En ejecución",
          "done": "Hecho",
          "failed": "Fallido"
        }
      },
      "templates": {
        "title": "Plantillas de informes",
        "subtitle": "Configura programaciones y prompts de IA para esta organización.",
        "create": "Nueva plantilla",
        "createTitle": "Crear plantilla de informe",
        "edit": "Editar",
        "editTitle": "Editar plantilla de informe",
        "formSubtitle": "Define qué cubre el informe, cuándo se ejecuta y quién lo recibe.",
        "sections": {
          "content": "Contenido del informe",
          "schedule": "Programación",
          "delivery": "Entrega y alcance"
        },
        "seed": "Cargar valores predeterminados",
        "seeded": "Se añadieron {count} plantilla(s).",
        "empty": "No hay plantillas aún. Carga los valores predeterminados o crea una.",
        "active": "Activo",
        "inactive": "Inactivo",
        "cron": "Programación",
        "sendByEmail": "Enviar por correo",
        "deactivate": "Desactivar",
        "deactivated": "Plantilla desactivada.",
        "activate": "Activar",
        "activated": "Plantilla activada.",
        "save": "Guardar",
        "saved": "Plantilla guardada.",
        "saveError": "No se pudo guardar la plantilla.",
        "loadError": "No se pudieron cargar las plantillas de informes.",
        "validationRequired": "Se requieren nombre y prompt.",
        "recipientsPlaceholder": "Seleccione miembros de la organización",
        "recipientsRequired": "Seleccione al menos un destinatario si el correo está activado.",
        "promptHint": "El acceso a los datos de la organización, los formularios seleccionados y el período se añade automáticamente.",
        "allFormsPlaceholder": "Todos los formularios (dejar vacío)",
        "advancedMode": "Prompt personalizado (avanzado, Jinja2)",
        "fields": {
          "name": "Nombre",
          "audience": "Audiencia",
          "prompt": "Instrucciones del informe",
          "responseLanguage": "Idioma de respuesta",
          "recipients": "Destinatarios",
          "formScope": "Formularios"
        },
        "schedule": {
          "label": "Programación",
          "none": "Sin programación",
          "daily": "Diario",
          "weekly": "Semanal",
          "monthly": "Mensual",
          "custom": "Personalizado (cron)",
          "time": "Hora",
          "weekday": "Día de la semana",
          "dayOfMonth": "Día del mes",
          "customCron": "Expresión cron",
          "humanDaily": "Cada día a las {time}",
          "humanWeekly": "Cada {weekday} a las {time}",
          "humanMonthly": "El día {day} de cada mes a las {time}",
          "weekdays": {
            "0": "Domingo",
            "1": "Lunes",
            "2": "Martes",
            "3": "Miércoles",
            "4": "Jueves",
            "5": "Viernes",
            "6": "Sábado"
          }
        },
        "audience": {
          "pm": "Gestor de proyecto",
          "field_coord": "Coordinador de campo",
          "statistician": "Estadístico",
          "executive": "Ejecutivo"
        }
      }
    },
    "chat": {
      "modeAsk": "Preguntar al agente",
      "description": "Pregunte sobre el esquema del formulario, envíos, análisis, reglas QC y estado de sincronización. Las respuestas están basadas en datos en tiempo real; los envíos de ejemplo pueden contener campos personales.",
      "question": "Su pregunta",
      "placeholder": "e.g. ¿Cuántas submisiones en los últimos 7 días? ¿Qué campos tiene este formulario?",
      "send": "Enviar",
      "empty": "Pregunte sobre los datos de este formulario.",
      "you": "Usted",
      "agent": "Agente",
      "generating": "El agente está buscando datos del formulario...",
      "sendHint": "Enter para enviar · Shift+Enter para una nueva línea"
    },
    "analytical": {
      "generate": "Ejecutar reporte analítico",
      "empty": "Ejecutar un reporte analítico para análisis detallado del formulario.",
      "queued": "Reporte en cola...",
      "status": "Estado: {status}",
      "done": "Reporte listo.",
      "failed": "Error al generar el reporte analítico.",
      "emptyResult": "El reporte terminó, pero no retornó contenido.",
      "timeout": "El reporte analítico tomó demasiado tiempo. Verifique que el worker de reportes del agente esté en ejecución.",
      "workerHint": "El trabajo aún está en cola. Inicie el servicio agent-reports-worker (docker compose up -d agent-reports-worker) y vuelva a intentarlo."
    },
    "qc": {
      "title": "Asistente QC AI",
      "description": "Describe una comprobación en lenguaje sencillo: el agente redactará una regla QC.",
      "checkDescription": "Descripción de la verificación",
      "checkPlaceholder": "e.g. la edad del respondente debe estar entre 18 y 65",
      "suggest": "Sugerir regla",
      "generating": "El agente está esbozando una regla...",
      "applyDraft": "Aplicar esbozo al formulario",
      "draftApplied": "Esbozo aplicado al formulario.",
      "draftPreview": "Regla sugerida",
      "viewRawResponse": "Ver respuesta completa del agente",
      "sendHint": "Enter para sugerir · Shift+Enter para una nueva línea",
      "noDraftParsed": "No se pudo analizar el JSON de esbozo de regla de la respuesta del agente.",
      "validationWarnings": "Notas de validación ({count}):",
      "starterPack": {
        "title": "Reglas de inicio QC",
        "description": "Revise el formulario y obtenga un conjunto de reglas sugeridas para comenzar la validación.",
        "focus": "Enfoque",
        "focusAll": "Mezcla balanceada",
        "focusRequired": "Campos requeridos solo",
        "focusConstraints": "Restricciones solo",
        "maxRules": "Max reglas",
        "suggest": "Sugerir reglas de inicio",
        "generating": "Revisando el formulario y esbozando reglas...",
        "apply": "Aplicar esta regla",
        "empty": "No se encontraron esbozos de reglas válidas. Intente nuevamente o use la sugerencia de regla única arriba.",
        "skippedHint": "{count} regla(s) sugerida(s) fueron ignorada(s) (duplicada, inválida o excedida el límite)."
      }
    },
    "xlsform": {
      "openButton": "XLSForm AI",
      "title": "Asistente AI XLSForm",
      "description": "Cargue un archivo de preguntas o describa la tarea — el agente esbozará, probará y solicitará confirmación de publicación.",
      "instruction": "Instrucción para el agente",
      "instructionPlaceholder": "e.g. crear un formulario de encuesta de satisfacción con 5 preguntas",
      "empty": "Describe qué formulario necesita o cargue un archivo — el agente esbozará y probará.",
      "send": "Enviar",
      "sendHint": "Enter to send · Shift+Enter for a new line",
      "working": "El agente está trabajando en la tarea...",
      "you": "Usted",
      "agent": "Agente",
      "publishTitle": "Confirmación de publicación",
      "publishDescription": "El agente solicitó la publicación de un borrador. Confirme manualmente — la publicación no puede continuar sin confirmación.",
      "formId": "ID del formulario (xmlFormId)",
      "versionOptional": "Versión (opcional)",
      "confirmPublish": "Confirmar publicación",
      "upload": {
        "hint": "Adjunte Excel/CSV, Word o texto con sus preguntas (máx. 5 MB)",
        "attachAria": "Adjuntar archivo",
        "removeAttachment": "Quitar adjunto",
        "selected": "Archivo: {name}",
        "attachmentPrefix": "[archivo: {name}]"
      },
      "session": {
        "resumeBanner": "Tiene una sesión AI XLSForm no finalizada (borrador: {formId})",
        "resumeButton": "Continuar",
        "startNewButton": "Empezar de nuevo",
        "dismissButton": "Descartar",
        "dismissError": "No se pudo descartar la sesión. Inténtelo de nuevo.",
        "historyButton": "Sesiones anteriores",
        "historyTitle": "Sesiones AI XLSForm",
        "historyHint": "Sesiones de los últimos 7 días. Continúe un borrador o vea una sesión publicada.",
        "historyEmpty": "No hay sesiones anteriores para este proyecto.",
        "historyFormColumn": "Borrador",
        "historyStatusColumn": "Estado",
        "historyUpdatedColumn": "Actualizado",
        "historyMessagesColumn": "Mensajes",
        "historyActionsColumn": "Acciones",
        "continueButton": "Continuar",
        "viewButton": "Ver",
        "continueError": "No se pudo reanudar la sesión. Inténtelo de nuevo.",
        "readOnlyHint": "Esta sesión fue publicada. Puede revisar el historial pero no enviar nuevos mensajes.",
        "draftUnknown": "sin nombre",
        "status": {
          "active": "Activa",
          "discarded": "Descartada",
          "failed": "Fallida",
          "published": "Publicada"
        }
      },
      "job": {
        "canClose": "Puede cerrar esta ventana: su sesión continuará en segundo plano.",
        "elapsed": "Trabajando… {time}",
        "agentWorking": "El agente está procesando su solicitud (LLM y herramientas MCP). Este paso puede tardar varios minutos.",
        "longWait": "Aún trabajando: verifique que el proxy LLM y el relay Hermes MCP estén saludables si esto tarda más de 10 minutos.",
        "timeout": "El asistente de formulario no terminó a tiempo. La sesión fallida se restableció; inténtelo de nuevo en una sesión nueva.",
        "failed": "El asistente de formulario falló. Intente nuevamente.",
        "phases": {
          "queued": "En cola",
          "planning": "Analizando su solicitud",
          "editing": "Editando preguntas del formulario",
          "uploading_draft": "Creando borrador de formulario",
          "testing_draft": "Probando borrador",
          "finalizing": "Preparando respuesta",
          "completed": "Completado"
        },
        "queuedFallback": "El trabajador aún no tomó el trabajo: el servidor lo reintentará en breve."
      },
      "preview": {
        "tabChat": "Chat",
        "tabPreview": "Vista previa",
        "loading": "Cargando la vista previa del formulario…",
        "empty": "No hay borrador para vista previa aún. Pida al asistente que cree o edite el formulario.",
        "error": "No se pudo cargar la vista previa del formulario.",
        "submitError": "No se pudo enviar la presentación de prueba."
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Sincronización completada: {formName}. Procesados {count} de {total} registros",
      "syncError": "Error de sincronización: {formName}. {error}",
      "formStatusChange": "Estado del formulario cambiado: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Programador: {status}. Trabajos activos: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "Validación QC completada: {instanceId}. Reglas: {totalRules}, aprobadas: {passedRules}, errores: {errorRules}, advertencias: {warningRules}",
      "projectStatusSummary": "Cambios críticos: {errorProjects} proyectos con errores, {errorForms} formularios con errores de {totalProjects} proyectos y {totalForms} formularios"
    },
    "connection": {
      "connected": "WebSocket conectado",
      "disconnected": "WebSocket desconectado",
      "reconnecting": "Reconectando...",
      "error": "Error de WebSocket: {error}",
      "maxRetriesReached": "Se alcanzó el número máximo de intentos de reconexión"
    },
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "realTimeUpdates": "Actualizaciones en tiempo real"
  },
  "buttonSelect": {
    "dark": "Oscuro",
    "light": "Claro"
  },
  "odkOptions": {
    "themes": {
      "light": "Claro",
      "dark": "Oscuro"
    },
    "navigation": {
      "swipe": "Deslizar",
      "buttons": "Botones",
      "swipe_buttons": "Deslizar + Botones"
    },
    "formUpdate": {
      "manual": "Manual",
      "previously_downloaded": "Previo descargado",
      "match_exactly": "Coincidir exactamente"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Cada 15 minutos",
      "every_one_hour": "Cada 1 hora",
      "every_six_hours": "Cada 6 horas",
      "every_24_hours": "Cada 24 horas"
    },
    "autosend": {
      "off": "Desactivado",
      "wifi_only": "Solo Wi‑Fi",
      "cellular_only": "Solo datos móviles",
      "wifi_and_cellular": "Wi‑Fi y datos móviles"
    },
    "constraintBehavior": {
      "on_swipe": "Al deslizar",
      "on_finalize": "Al finalizar"
    },
    "imageSizes": {
      "original": "Original",
      "very_small": "Muy pequeño",
      "small": "Pequeño",
      "medium": "Mediano",
      "large": "Grande"
    },
    "guidanceHint": {
      "no": "No",
      "yes": "Sí",
      "yes_collapsed": "Sí (colapsado)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Normal",
      "terrain": "Terreno",
      "hybrid": "Híbrido",
      "satellite": "Satélite",
      "light": "Claro",
      "dark": "Oscuro",
      "satellite_streets": "Satélite + calles",
      "outdoors": "Aire libre",
      "topographic": "Topográfico",
      "positron": "Positron",
      "dark_matter": "Materia oscura"
    },
    "fontSizes": {
      "small": "Pequeño",
      "normal": "Normal",
      "large": "Grande",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "Gestión de usuarios",
    "subtitle": "Gestione los miembros de la organización, filtre por actividad y actualice los registros de acceso.",
    "searchUser": "Buscar usuario",
    "addUser": "Agregar usuario",
    "editUser": "Editar usuario",
    "deleteUser": "Eliminar usuario",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "fullName": "Nombre completo",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "enterEmail": "Ingresar correo electrónico",
    "userCreated": "Usuario creado exitosamente",
    "userUpdated": "Usuario actualizado exitosamente",
    "userDeleted": "Usuario eliminado exitosamente",
    "confirmDeleteUser": "¿Está seguro de que desea eliminar este usuario?",
    "projectSelection": {
      "archived": "Archivado",
      "noProjects": "No hay proyectos disponibles",
      "noProjectsDescription": "No hay proyectos disponibles para asignación",
      "errorLoadingProjects": "Error al cargar proyectos"
    },
    "admin": "Administrador",
    "data_collector": "Recopilador de datos",
    "supervisor": "Supervisor(a)",
    "user": "Usuario",
    "owner": "Propietario",
    "isClient": "Cliente",
    "active": "Activo",
    "inactive": "Inactivo",
    "refresh": "Actualizar",
    "unsavedChanges": "El formulario tiene cambios no guardados. ¿Está seguro de que desea cerrarlo?",
    "validation": {
      "passwordRequired": "La contraseña es obligatoria",
      "passwordMinLength": "La contraseña debe tener al menos 8 caracteres",
      "confirmPasswordRequired": "Por favor confirme la contraseña",
      "passwordsDontMatch": "Las contraseñas no coinciden"
    },
    "editUserDescription": "Actualizar detalles del usuario",
    "addUserDescription": "Crear un nuevo usuario en el sistema",
    "basicInformation": "Información básica",
    "fullNamePlaceholder": "Ingrese nombre completo",
    "passwordSettings": "Configuración de contraseña",
    "passwordPlaceholder": "Ingrese contraseña",
    "confirmPasswordPlaceholder": "Confirmar contraseña",
    "passwordHelp": "La contraseña debe tener al menos 8 caracteres",
    "userSettings": "Configuración de usuario",
    "clientUserDescription": "El usuario cliente tiene acceso limitado",
    "inactiveUserDescription": "Los usuarios inactivos no pueden iniciar sesión en el sistema",
    "noName": "Sin nombre"
  },
  "user": {
    "system": "Sistema",
    "account": "Cuenta",
    "explore": "Explorar",
    "profile": "Perfil",
    "logout": "Cerrar sesión",
    "settings": "Configuración",
    "projects": "Proyectos",
    "faq": "Ayuda",
    "helpAndSupport": "Ayuda y soporte",
    "administration": "Administración",
    "help": "Ayuda"
  },
  "odkSync": {
    "dashboard": {
      "title": "Panel de Sincronización ODK"
    },
    "workbench": {
      "contextHint": "Monitore la ingesta de datos desde servidores ODK y gestione cursores de sincronización en toda su organización.",
      "live": "Actualizaciones en vivo",
      "reconnect": "Reconectar",
      "loading": "Cargando datos de sincronización…",
      "schedulerPill": "Programador",
      "schedulerActive": "Activo",
      "schedulerPaused": "Pausado",
      "schedulerStopped": "Detenido",
      "statusLive": "En vivo",
      "statusOffline": "Desconectado",
      "statusSchedulerActive": "Activo",
      "statusSchedulerPaused": "Pausado",
      "statusSchedulerStopped": "Detenido",
      "createShort": "Nuevo",
      "pipeline": {
        "ariaLabel": "Estado de la tubería de sincronización",
        "scheduler": "Programador",
        "schedulerActive": "Ejecutando según el programa",
        "schedulerPaused": "Pausado — envíos no sincronizados",
        "pull": "Última extracción",
        "cursors": "Cursores",
        "cursorsHint": "{count} formularios rastreados",
        "cursorsEmpty": "No hay cursores todavía"
      }
    },
    "table": {
      "emptyState": "No hay cursores de sincronización todavía. Cree uno para comenzar a extraer envíos."
    },
    "scheduler": {
      "title": "Programador de Sincronización",
      "pauseScheduler": "Pausar Programador",
      "resumeScheduler": "Reanudar Programador",
      "pausedMessage": "La sincronización de datos ODK está actualmente pausada. Las nuevas presentaciones no se sincronizarán hasta que se reanude."
    },
    "managerScope": {
      "title": "Visualización de datos de sincronización",
      "message": "Estás viendo datos de sincronización para {count} proyecto(s) que gestionas. Solo puedes ver y controlar la sincronización para los proyectos donde tienes el rol de gestor."
    },
    "statistics": {
      "title": "Estadísticas de Sincronización",
      "totalCursors": "Total de Cursores",
      "lastSync": "Última Sincronización"
    },
    "cursors": {
      "title": "Cursores de Sincronización",
      "viewModes": {
        "cards": "Tarjetas",
        "table": "Tabla",
        "projects": "Por Proyectos",
        "list": "Lista"
      },
      "actions": {
        "clear": "Limpiar",
        "bulkSync": "Sincronización Masiva ({count})",
        "bulkReset": "Reinicio Masivo ({count})",
        "createCursor": "Crear Cursor"
      }
    },
    "auto": {
      "managed": "Automático",
      "manual": "Manual",
      "enableAuto": "Habilitar Automático ({count})",
      "disableAuto": "Deshabilitar Automático ({count})",
      "reason": "Razón",
      "reasons": {
        "importedActive": "Formulario activo importado",
        "createdActive": "Formulario activo creado",
        "uploadedActive": "Formulario activo subido",
        "formOpened": "Formulario abierto",
        "formClosed": "Formulario cerrado",
        "formReopened": "Formulario reabierto",
        "newFormOpened": "Nuevo formulario abierto",
        "migrated": "Migrado",
        "formNotFound": "Formulario no encontrado",
        "manualOverride": "Sobrescritura manual",
        "formDeleted": "Formulario eliminado",
        "importedFormDeleted": "Formulario importado eliminado"
      }
    },
    "projectSummary": {
      "forms": "Formularios: {count}",
      "lastSync": "Última Sincronización",
      "active": "Activos: {count}",
      "errors": "Errores: {count}",
      "inactive": "Inactivos: {count}",
      "noProjects": "Sin Proyectos",
      "createFirstCursor": "Cree su primer cursor de sincronización"
    },
    "projectResponsible": {
      "responsible": "Responsable",
      "notAssigned": "No asignado",
      "assign": "Asignar",
      "remove": "Quitar",
      "assignModal": {
        "title": "Asignar responsable para el proyecto \"{project}\"",
        "selectUser": "Seleccionar usuario",
        "selectUserPlaceholder": "Seleccionar persona responsable",
        "assign": "Asignar",
        "noUsers": "No hay usuarios disponibles",
        "noUsersMessage": "No hay usuarios en la organización para asignar como responsable del proyecto."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Crear Cursor de Sincronización",
        "server": "Servidor",
        "project": "Proyecto",
        "xmlForm": "Formulario XML",
        "serverPlaceholder": "Seleccionar servidor",
        "projectPlaceholder": "Seleccionar proyecto",
        "xmlFormPlaceholder": "Seleccionar formulario"
      },
      "manualSync": {
        "title": "Sincronización Manual",
        "selectCursors": "Seleccionar Cursores",
        "forceFullSync": "Forzar Sincronización Completa",
        "maxConcurrent": "Máximo de Sincronizaciones Concurrentes",
        "startSync": "Iniciar Sincronización"
      }
    },
    "messages": {
      "schedulerPaused": "Programador de sincronización ODK pausado",
      "schedulerResumed": "Programador de sincronización ODK reanudado",
      "cursorCreated": "Cursor de sincronización creado exitosamente",
      "manualSyncTriggered": "Sincronización manual iniciada exitosamente",
      "cursorReset": "Cursor reiniciado exitosamente",
      "bulkResetSuccess": "Se reiniciaron exitosamente {count} cursores",
      "selectCursorsForSync": "Por favor seleccione al menos un cursor para sincronización",
      "never": "Nunca"
    },
    "errors": {
      "failedToLoadSyncData": "Error al cargar datos de sincronización",
      "failedToControlScheduler": "Error al controlar el programador",
      "failedToCreateCursor": "Error al crear cursor de sincronización",
      "failedToTriggerManualSync": "Error al iniciar sincronización manual",
      "failedToResetCursor": "Error al reiniciar cursor",
      "failedToResetSomeCursors": "Error al reiniciar algunos cursores"
    },
    "filters": {
      "showAllForms": "Mostrar todos los cursores",
      "filteringTitle": "Filtrado de cursores",
      "filteringMessage": "Mostrando {filtered} de {total} cursores. Ocultos {hidden} cursores inactivos."
    },
    "formStatus": {
      "title": "Estado de formularios y optimización",
      "checkStatuses": "Verificar estados",
      "statusLabels": {
        "open": "Abiertos",
        "closing": "Cerrando",
        "closed": "Cerrados",
        "unknown": "Desconocido"
      },
      "cards": {
        "title": "Estado de formularios",
        "description": "Verificar y optimizar cursores",
        "refresh": "Actualizar"
      },
      "loading": "Cargando...",
      "autoCheckInterval": "5 minutos",
      "lastCheck": "Automáticamente cada 5 minutos",
      "benefits": {
        "autoDisable": "Deshabilitación automática de cursores para formularios cerrados",
        "resourceOptimization": "Optimización de recursos de sincronización",
        "performanceImprovement": "Rendimiento mejorado"
      },
      "messages": {
        "checkStarted": "Verificación de estado de formularios iniciada",
        "checkError": "Error al verificar estados de formularios",
        "enableError": "Error al habilitar cursores",
        "disableError": "Error al deshabilitar cursores"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "Dashboard QC - Calidad de Datos ODK",
      "description": "Monitoreo de la calidad de datos de envíos ODK usando reglas de validación"
    },
    "statistics": {
      "totalRules": "Total de Reglas",
      "activeRules": "Reglas Activas",
      "inactiveRules": "Reglas Inactivas",
      "recentValidations": "Validaciones Recientes"
    },
    "sections": {
      "rulesByType": "Reglas por Tipo",
      "rulesBySeverity": "Reglas por Nivel de Severidad",
      "qcRules": "Reglas QC"
    },
    "filters": {
      "allTypes": "Todos los Tipos",
      "allLevels": "Todos los Niveles",
      "allStatuses": "Todos los Estados",
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "actions": {
      "createRule": "Crear Regla",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "clearSelection": "Limpiar Selección"
    },
    "ruleTypes": {
      "required": "Requerido",
      "constraint": "Restricción",
      "calculation": "Cálculo",
      "custom": "Personalizado"
    },
    "severityLevels": {
      "error": "Error",
      "warning": "Advertencia",
      "info": "Información"
    },
    "messages": {
      "noRuleTypeData": "No hay datos de tipos de reglas disponibles",
      "noSeverityData": "No hay datos de severidad disponibles",
      "ruleUpdated": "Regla actualizada exitosamente",
      "ruleCreated": "Regla creada exitosamente",
      "ruleSaveError": "Error al guardar la regla",
      "ruleLoadError": "Error al cargar datos",
      "ruleStatusToggled": "Estado de la regla {ruleName} cambiado",
      "ruleStatusError": "Error al cambiar el estado de la regla",
      "confirmDeleteRule": "¿Eliminar regla \"{ruleName}\"?",
      "ruleDeleted": "Regla eliminada exitosamente",
      "ruleDeleteError": "Error al eliminar la regla",
      "ruleSaved": "Regla guardada exitosamente",
      "bulkStatusToggled": "Estado cambiado para {count} reglas",
      "bulkStatusError": "Error al cambiar el estado de las reglas",
      "bulkDeleted": "Eliminadas {count} reglas",
      "bulkDeleteError": "Error al eliminar las reglas",
      "rulesDeleted": "Reglas eliminadas",
      "rulesActivated": "Reglas activadas",
      "rulesDeactivated": "Reglas desactivadas",
      "ruleNotFound": "Regla no encontrada",
      "invalidJsonFormat": "Formato JSON inválido",
      "createExpressionFirst": "Crear expresión primero",
      "previewError": "Error durante la vista previa",
      "invalidRuleExpression": "Expresión de regla inválida",
      "ruleNotExecuted": "Regla no ejecutada",
      "loadingRule": "Cargando regla...",
      "saving": "Guardando...",
      "loading": "Cargando...",
      "run": "Ejecutar",
      "passed": "Aprobado",
      "failed": "Fallado",
      "success": "Éxito",
      "errorDuringValidation": "Error durante la validación",
      "noQcRulesFound": "No se encontraron reglas QC"
    },
    "form": {
      "ruleName": "Nombre de la Regla",
      "ruleNameRequired": "El nombre de la regla es requerido",
      "fieldPath": "Campo Principal",
      "fieldPathRequired": "El campo principal es requerido",
      "fieldPathHint": "El campo principal que valida esta regla. Se pueden usar otros campos en la expresión JSONLogic.",
      "errorMessage": "Mensaje de Error",
      "errorMessageHint": "Mostrado a los revisores cuando un envío falla esta regla.",
      "errorMessageRequired": "El mensaje de error es requerido",
      "constraintExpression": "Expresión de Restricción",
      "constraintExpressionHint": "Use '{'\"var\": \"field_name\"'}' para referenciar campos de envío. Haga clic en Aplicar para validar JSON.",
      "constraintExpressionRequired": "La expresión de restricción es requerida",
      "ruleType": "Tipo de Regla",
      "severityLevel": "Nivel de Severidad",
      "ruleActive": "La regla está activa",
      "ruleActiveHint": "Las reglas inactivas se mantienen pero no se aplican durante la validación.",
      "basicSettings": "Configuración Básica",
      "jsonLogicBuilder": "Constructor JSONLogic",
      "jsonLogicBuilderHint": "Define cuando esta regla pasa. La expresión debe evaluar a verdadero para envíos válidos.",
      "reset": "Reiniciar",
      "apply": "Aplicar",
      "saveChanges": "Guardar Cambios",
      "createRule": "Crear Regla",
      "editRule": "Editar Regla",
      "rulePreview": "Vista Previa de Regla",
      "testRuleOnSample": "Probar regla en datos de muestra",
      "detailedResults": "Resultados Detallados",
      "showSubmissionData": "Mostrar datos de envío",
      "help": "Ayuda",
      "ruleTypes": "Tipos de Regla",
      "severityLevels": "Niveles de Severidad",
      "requiredField": "Campo requerido",
      "constraintCheck": "Verificación de restricción",
      "calculatedField": "Campo calculado",
      "customLogic": "Lógica personalizada",
      "blocksSubmission": "Bloquea envío",
      "showsWarning": "Muestra advertencia",
      "informationalMessage": "Mensaje informativo",
      "jsonLogicExamplesTitle": "Ejemplos de expresiones JSONLogic para hh_question:",
      "agreementCheckExample": "Verificación de acuerdo:",
      "finalStatusCheckExample": "Verificación de estado final:",
      "enumeratorCheckExample": "Verificación de enumerador:",
      "complexLogicExample": "Lógica compleja:",
      "fieldValue": "Valor del campo",
      "previewStatsLine": "{passed} aprobados · {failed} fallidos · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Buscar por nombre, campo o mensaje...",
      "ruleType": "Tipo de regla",
      "severityLevel": "Nivel de severidad",
      "status": "Estado",
      "enterRuleName": "Ingrese el nombre de la regla",
      "enterErrorMessage": "Ingrese el mensaje de error",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Deshabilitar regla",
        "enableRule": "Habilitar regla"
      }
    },
    "viewModes": {
      "cards": "Tarjetas",
      "table": "Tabla"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Monitor de Limpieza de Datos ODK",
      "subtitle": "Monitorear el sistema de limpieza automática y ver estadísticas de datos",
      "selectFormTitle": "Seleccionar Formulario para Monitoreo de Limpieza",
      "currentProject": "Proyecto Actual",
      "searchPlaceholder": "Buscar y seleccionar formulario...",
      "systemInfo": {
        "title": "Sistema de Limpieza Automática",
        "activeFormsTitle": "Formularios activos (abiertos/cerrando)",
        "activeFormsDesc": "Solo se conservan automáticamente las 5 carpetas más recientes. La limpieza ocurre durante cada sincronización.",
        "closedFormsTitle": "Formularios cerrados (cerrados)",
        "closedFormsDesc": "Cuando se cierra un formulario, se archivan automáticamente 4 carpetas, dejando 1 para estadísticas.",
        "monitoringTitle": "Monitoreo",
        "monitoringDesc": "Seleccione un formulario arriba para ver estadísticas y monitorear el sistema de limpieza."
      }
    },
    "manager": {
      "title": "Gestor de Limpieza de Datos ODK",
      "loading": "Cargando datos de limpieza...",
      "noData": {
        "title": "No hay datos disponibles",
        "meaning": "Qué significa esto:",
        "noSubmissions": "Este formulario aún no tiene envíos",
        "noSync": "El formulario no se ha sincronizado desde ODK Central",
        "noCleanupNeeded": "No se necesita limpieza en este momento"
      },
      "errorLoading": "Error al cargar datos",
      "stats": {
        "title": "Estadísticas Actuales",
        "totalFolders": "Carpetas Totales",
        "totalSize": "Tamaño Total",
        "completeData": "Datos Completos"
      },
      "formInfo": {
        "title": "Información del Formulario",
        "state": "Estado:",
        "active": "Activo:",
        "lastSubmission": "Último Envío:",
        "lastSync": "Última Sincronización:",
        "yes": "Sí",
        "no": "No"
      },
      "recommendation": {
        "title": "Recomendación de Limpieza",
        "action": "Acción:",
        "reason": "Razón:",
        "requiresApproval": "Requiere aprobación para la limpieza"
      },
      "buttons": {
        "refresh": "Actualizar Estadísticas",
        "dryRun": "Simulacro",
        "cleanupNow": "Limpiar Ahora",
        "forceCleanup": "Forzar Limpieza"
      },
      "results": {
        "title": "Resultado de la Última Limpieza",
        "strategy": "Estrategia:",
        "kept": "Conservado: {count} carpetas",
        "deleted": "Eliminado: {count} carpetas",
        "archived": "Archivado: {count} carpetas",
        "skipped": "Omitido: {count} carpetas"
      },
      "folders": {
        "title": "Carpetas Recientes ({count})",
        "columns": {
          "name": "Nombre de Carpeta",
          "created": "Creado",
          "size": "Tamaño (MB)",
          "files": "Archivos"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Limpieza global completada exitosamente",
      "globalCleanupFailed": "La limpieza global falló",
      "errorLoadingProjects": "Error al cargar proyectos",
      "errorLoadingForms": "Error al cargar formularios",
      "noDataOrSync": "Este formulario no tiene datos o aún no se ha sincronizado",
      "statsLoadFailed": "Error al cargar estadísticas de limpieza",
      "dryRunSuccess": "Simulacro completado - no se eliminaron archivos",
      "dryRunFailed": "El simulacro falló",
      "cleanupNotRecommended": "Limpieza no recomendada para este formulario",
      "cleanupSuccess": "Limpieza completada exitosamente",
      "cleanupFailed": "La limpieza falló",
      "forceNotAvailable": "Limpieza forzada no disponible para este formulario",
      "forceConfirm": "¿Está seguro de que desea forzar la limpieza? Esta acción no se puede deshacer.",
      "forceSuccess": "Limpieza forzada completada exitosamente",
      "forceFailed": "La limpieza forzada falló"
    }
  },
  "permissionGroups": {
    "create": "Crear grupo",
    "delete": "Eliminar grupo",
    "assignToUser": "Asignar grupo al usuario",
    "removeFromUser": "Remover grupo del usuario",
    "roleNames": {
      "manager": "Gerente",
      "projectMember": "Miembro del proyecto",
      "dataViewer": "Visor de datos",
      "dataCollector": "Recopilador de datos",
      "dataDownloader": "Descargador de datos",
      "dataAnalyst": "Analista de datos",
      "qcViewer": "Visor de QC",
      "qcEditor": "Editor de QC",
      "monitor": "Monitor",
      "formDesigner": "Diseñador de formularios"
    },
    "userManagement": {
      "clientGroups": "Grupos de clientes",
      "clientGroupsDescription": "Grupos destinados a usuarios externos o de cliente.",
      "regularGroups": "Grupos regulares",
      "regularGroupsDescription": "Grupos destinados a miembros internos del proyecto.",
      "errorTitle": "No se pudieron cargar los grupos",
      "noProjectsTitle": "Seleccione primero un proyecto",
      "noProjectsDescription": "Elija un proyecto antes de asignar grupos de permisos.",
      "noGroupsTitle": "No hay grupos disponibles",
      "noGroupsAvailable": "No hay grupos disponibles para asignar",
      "errorLoadingGroups": "Error al cargar grupos",
      "selectedGroups": "Grupos seleccionados",
      "selectedCount": "{count} seleccionados",
      "selectedPill": "Seleccionado",
      "includedPermissions": "Permisos incluidos",
      "groupDetailsTitle": "Detalles del grupo",
      "groupDescriptionFallback": "No se proporcionó descripción.",
      "rolesCount": "Roles: {count}",
      "viewGroupDetails": "Ver roles en {name}"
    }
  },
  "menu": {
    "dashboard": "Panel",
    "my-organization": "Mi Organización",
    "userManagement": "Gestión de usuarios",
    "organizationStats": "Estadísticas de la organización",
    "organizationSettings": "Configuración de la organización",
    "projects": "Proyectos",
    "odkSync": "Sincronización ODK",
    "odkQc": "Calidad de Datos QC",
    "payments": "Pagos",
    "faq": "Ayuda",
    "preferences": "Preferencias",
    "settings": "Configuración",
    "billing": "Facturación",
    "help": "Ayuda"
  },
  "organization": {
    "settingsSubtitle": "Gestione el perfil de la organización, la suscripción de IA, los mapas y la infraestructura conectada.",
    "profile": {
      "sectionTitle": "Perfil de la organización",
      "name": "Nombre",
      "description": "Descripción",
      "edit": "Editar",
      "editTitle": "Editar organización",
      "noDescription": "Sin descripción",
      "created": "Creada",
      "updated": "Actualizada",
      "loadError": "No se pudo cargar el perfil de la organización"
    },
    "infrastructure": {
      "sectionTitle": "Infraestructura conectada",
      "subtitle": "Resumen de servidores, proyectos, usuarios y formularios activos.",
      "servers": "Servidores ODK",
      "projects": "Proyectos",
      "users": "Usuarios",
      "activeForms": "Formularios activos",
      "defaultServer": "Servidor ODK predeterminado",
      "noDefaultServer": "No hay servidor predeterminado",
      "manageServers": "Gestionar servidores ODK",
      "viewSync": "Abrir Sync Workbench",
      "loadError": "No se pudo cargar el resumen de infraestructura"
    },
    "quickLinks": {
      "sectionTitle": "Páginas relacionadas",
      "userManagement": "Gestión de usuarios",
      "statistics": "Estadísticas de la organización",
      "projects": "Proyectos",
      "reportTemplates": "Plantillas de informes",
      "odkServers": "Servidores ODK",
      "syncWorkbench": "Sincro"
    }
  },
  "preferences": {
    "title": "Preferencias",
    "subtitle": "Revise su perfil de cuenta, acceso a la organización, grupos de permisos y roles de proyecto.",
    "accessOverview": "Resumen de acceso",
    "organizationOwner": "Propietario de la organización",
    "organizationOwnerDescription": "Tiene acceso completo a todos los recursos y proyectos de la organización.",
    "permissionGroups": "Grupos de permisos",
    "permissionGroupsDescription": "Grupos por proyecto y sus roles",
    "perProject": "Por proyecto",
    "noProjectGroups": "No hay grupos específicos del proyecto.",
    "projectsAccess": "Acceso a proyectos",
    "projectsAccessDescription": "Proyectos que puede abrir y sus roles",
    "ownerNoProjects": "Como propietario de la organización, tiene acceso completo. Los proyectos aparecerán una vez creados o importados.",
    "noProjectAccess": "Aún no se le ha concedido acceso a ningún proyecto.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Proyecto #{id}",
    "memberSince": "Miembro desde:",
    "userFallback": "Usuario",
    "invalidDate": "Fecha no válida",
    "name": "Nombre",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "resetPassword": "Restablecer contraseña",
    "emailSubscriptions": "Suscripciones por correo",
    "emailSubscriptionsVisit": "Para gestionar qué correos recibe, visite",
    "notificationSettingsLink": "Configuración de notificaciones",
    "cancelAccount": "Eliminar cuenta",
    "cancelAccountDescription": "Eliminar permanentemente su organización, usuarios y todos los datos asociados.",
    "cancelAccountAction": "Eliminar cuenta",
    "editName": "Editar nombre",
    "editNameSubtitle": "Actualice el nombre que se muestra en la aplicación.",
    "nameRequired": "El nombre es obligatorio",
    "nameMinLength": "El nombre debe tener al menos 2 caracteres",
    "nameUpdateFailed": "Error al actualizar el nombre. Inténtelo de nuevo.",
    "nameChangedSuccess": "Ha cambiado su nombre correctamente",
    "resetPasswordTitle": "Restablecer contraseña",
    "resetPasswordSubtitle": "Introduzca su contraseña actual y elija una nueva.",
    "passwordRequirementsTitle": "Requisitos de contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "repeatNewPassword": "Repetir nueva contraseña",
    "passwordMinLength": "Debe tener al menos 8 caracteres",
    "passwordUniqueChars": "Debe contener al menos 6 caracteres únicos",
    "updatePassword": "Actualizar contraseña",
    "passwordChangedSuccess": "Ha cambiado su contraseña correctamente",
    "passwordUpdateFailed": "Error al actualizar la contraseña. Inténtelo de nuevo.",
    "currentPasswordRequired": "El campo de contraseña actual es obligatorio",
    "newPasswordRequired": "El campo de nueva contraseña es obligatorio",
    "repeatPasswordRequired": "El campo de repetir contraseña es obligatorio",
    "passwordMatchUnique": "La nueva contraseña no puede ser igual a la actual",
    "confirmPasswordMismatch": "La confirmación no coincide con la nueva contraseña",
    "dangerZoneTitle": "Zona de peligro",
    "dangerZoneSubtitle": "Acciones irreversibles que afectan a toda su organización.",
    "cancelAccountModalTitle": "Eliminar cuenta",
    "cancelAccountModalSubtitle": "Verifique su identidad y confirme que desea eliminar su cuenta de forma permanente.",
    "cancelAccountConsequenceOrg": "Su organización y todos los proyectos serán eliminados",
    "cancelAccountConsequenceUsers": "Todos los miembros de la organización perderán el acceso",
    "cancelAccountConsequenceOdk": "Los datos ODK vinculados pueden eliminarse de forma permanente",
    "cancelAccountConsequenceIrreversible": "Esta acción no se puede deshacer",
    "cancelAccountConfirmEmailLabel": "Escriba su dirección de correo para confirmar",
    "cancelAccountConfirmEmailRequired": "La confirmación del correo es obligatoria",
    "cancelAccountConfirmEmailMismatch": "El correo no coincide con su cuenta",
    "cancelAccountAcknowledge": "Entiendo que esto eliminará permanentemente mi organización y todos los datos asociados",
    "cancelAccountAcknowledgeRequired": "Debe confirmar que comprende las consecuencias",
    "cancelAccountDeleteButton": "Eliminar cuenta permanentemente",
    "cancelAccountUnavailableTitle": "La eliminación de cuenta aún no está disponible",
    "cancelAccountUnavailableMessage": "Su identidad fue verificada. La eliminación de cuenta está en preparación — contacte a su administrador o soporte para solicitar el cierre de la cuenta.",
    "cancelAccountWrongPassword": "Contraseña incorrecta. Inténtelo de nuevo.",
    "dangerZoneCancelAccount": "Zona de peligro: Eliminar cuenta",
    "cancelAccountWarning": "Esto eliminará permanentemente su cuenta y todos los datos asociados, incluida su organización, usuarios y datos ODK vinculados.",
    "groupFallback": "Grupo"
  },
  "faq": {
    "title": "Ayuda",
    "subtitle": "Guías breves y respuestas para tareas habituales de UDACAPI."
  },
  "settings": {
    "title": "Configuración",
    "subtitle": "Ajuste la apariencia de la aplicación, el idioma y las preferencias de notificación.",
    "themeSection": "Tema",
    "generalSection": "Preferencias generales",
    "notificationsNoticeTitle": "Sus configuraciones de notificación se han reorganizado y simplificado",
    "notificationsNoticeBody": "Sus anteriores opciones de configuración no han cambiado."
  },
  "projects": {
    "pageTitle": "Proyectos",
    "subtitle": "Gestione sus proyectos, cambie entre tarjetas y tablas, y inicie flujos de importación o creación.",
    "refresh": "Actualizar",
    "createProject": "Crear Proyecto",
    "importRestrictions": {
      "message": "La importación de proyectos está permitida solo en servidores que pertenezcan a la organización. Los servidores Shared y Global no pueden ser utilizados para importar proyectos."
    },
    "viewMode": {
      "cards": "Tarjetas",
      "table": "Tabla"
    },
    "sections": {
      "forms": {
        "title": "Formularios del proyecto"
      },
      "users": {
        "title": "Usuarios del proyecto"
      },
      "formAccess": {
        "title": "Acceso a formularios",
        "description": "Elija qué App Users pueden descargar cada formulario en ODK Collect.",
        "save": "Guardar",
        "discard": "Descartar",
        "saving": "Guardando…",
        "saved": "Acceso a formularios guardado",
        "saveError": "No se pudieron guardar todos los cambios",
        "loadError": "No se pudo cargar el acceso a formularios",
        "emptyForms": "No hay formularios publicados en este proyecto",
        "emptyAppUsers": "Aún no hay App Users. Cree primero un código QR.",
        "openQr": "Abrir QR workbench",
        "openForms": "Abrir formularios",
        "dirtyHint": "Cambios sin guardar"
      },
      "info": {
        "title": "Información del proyecto",
        "basicInfo": "Información básica",
        "accessInfo": "Acceso",
        "statistics": "Estadísticas del proyecto",
        "fields": {
          "projectId": "ID del proyecto",
          "name": "Nombre",
          "description": "Descripción",
          "status": "Estado",
          "orgId": "ID de organización",
          "odkProjectId": "ID de proyecto ODK",
          "createdAt": "Fecha de creación",
          "updatedAt": "Última actualización",
          "yourRole": "Su rol",
          "canManageForms": "Puede gestionar formularios",
          "canViewUsers": "Puede ver usuarios",
          "isManager": "Es manager",
          "isOwner": "Es propietario",
          "totalUsers": "Usuarios del proyecto"
        },
        "status": {
          "active": "Activo",
          "archived": "Archivado"
        },
        "noDescription": "Sin descripción",
        "loading": "Cargando información del proyecto...",
        "loadError": "Error al cargar la información del proyecto",
        "statsLoadError": "Error al cargar las estadísticas del proyecto",
        "invalidDate": "Fecha no válida",
        "notAvailable": "N/D"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Agregar usuario al proyecto",
        "editTitle": "Editar acceso al proyecto",
        "addSubtitle": "Primero seleccione un usuario y luego asigne grupos de permisos para este proyecto.",
        "editSubtitle": "Revise el usuario seleccionado y actualice los grupos de permisos para este proyecto.",
        "stepOne": "Paso 1",
        "stepTwo": "Paso 2",
        "stepReady": "Listo",
        "stepRequired": "Obligatorio",
        "stepLocked": "Bloqueado",
        "selectUserTitle": "Seleccionar usuario",
        "selectedUser": "Usuario seleccionado",
        "selectUserHint": "Elija quién debe recibir acceso a este proyecto.",
        "selectedUserHint": "Este usuario ya está asignado al proyecto. Puede actualizar sus grupos de permisos abajo.",
        "selectUserPlaceholder": "Seleccione un usuario",
        "selectUserHelper": "Los propietarios y superusuarios no aparecen en esta lista.",
        "permissionGroupsTitle": "Grupos de permisos",
        "permissionGroupsHint": "Seleccione uno o más grupos de permisos para el usuario seleccionado.",
        "permissionGroupsLockedTitle": "Seleccione un usuario para continuar",
        "permissionGroupsLockedHint": "Los grupos de permisos estarán disponibles después de elegir un usuario.",
        "addToProject": "Agregar al proyecto",
        "clientUser": "Usuario cliente",
        "internalUser": "Usuario interno"
      },
      "dialogs": {
        "removeUser": {
          "title": "Eliminar usuario del proyecto",
          "message": "¿Realmente desea eliminar a este usuario del proyecto?",
          "confirm": "Eliminar"
        }
      },
      "list": {
        "searchPlaceholder": "Buscar usuarios",
        "filterByPermissionGroups": "Filtrar por grupos de permisos",
        "accessDeniedTitle": "Acceso denegado",
        "accessDeniedMessage": "No tiene permisos para ver los usuarios de este proyecto.",
        "loadErrorTitle": "No se pudieron cargar los usuarios del proyecto",
        "emptyTitle": "Todavía no hay usuarios en el proyecto",
        "emptyMessage": "Agregue el primer usuario para empezar a gestionar el acceso al proyecto.",
        "emptyFilteredTitle": "Ningún usuario coincide con los filtros actuales",
        "emptyFilteredMessage": "Intente cambiar el texto de búsqueda o los grupos de permisos seleccionados.",
        "noPermissionGroups": "Sin grupos de permisos"
      },
      "messages": {
        "saveSuccess": "El acceso del usuario se actualizó correctamente.",
        "removeSuccess": "El usuario fue eliminado del proyecto."
      },
      "errors": {
        "assignGroupsFailed": "No se pudieron asignar los grupos de permisos. Inténtelo de nuevo.",
        "assignRoleFailed": "No se pudo asignar el rol del proyecto.",
        "loadUsersFailed": "No se pudieron cargar los usuarios del proyecto.",
        "permissionGroupsLoadFailed": "No se pudieron cargar los grupos de permisos.",
        "projectMemberRoleFailed": "No se pudo resolver el rol project member.",
        "removeUserFailed": "No se pudo eliminar el usuario del proyecto.",
        "rolesLoadFailed": "No se pudieron cargar los roles del proyecto.",
        "saveUserFailed": "No se pudo actualizar el acceso al proyecto."
      }
    },
    "modal": {
      "addProject": "Agregar proyecto",
      "editProject": "Editar proyecto",
      "unsavedChanges": "El formulario tiene cambios sin guardar. ¿Está seguro de que desea cerrarlo?"
    },
    "form": {
      "projectName": {
        "label": "Nombre del Proyecto",
        "placeholder": "Ingrese el nombre del proyecto",
        "required": "El nombre del proyecto es obligatorio"
      },
      "odkServer": {
        "label": "Servidor ODK",
        "placeholder": "Seleccionar servidor ODK",
        "required": "El servidor ODK es obligatorio",
        "noServers": "No hay servidores ODK disponibles. Por favor, agregue un servidor primero."
      },
      "description": {
        "label": "Descripción",
        "placeholder": "Descripción opcional del proyecto"
      },
      "buttons": {
        "cancel": "Cancelar"
      }
    },
    "cards": {
      "noProjects": "No hay proyectos",
      "status": {
        "active": "Activo",
        "archived": "Archivado"
      }
    },
    "confirmations": {
      "odkServerRequired": "Por favor, agregue al menos un servidor ODK antes de crear un proyecto.",
      "delete": {
        "imported": {
          "title": "Eliminar proyecto importado",
          "message": "¿Está seguro de que desea eliminar el proyecto \"{name}\"?\n\nEste proyecto fue importado desde ODK Central. Solo se eliminará de la base de datos de esta aplicación, pero permanecerá en el servidor ODK Central.",
          "messageWithStats": "¿Está seguro de que desea eliminar el proyecto \"{name}\"?\n\nEste proyecto contiene {formsCount} formularios y {submissionsCount} envíos.\nEl proyecto se archivará/ocultará (soft-delete), y los datos se conservarán.\n\nEste proyecto fue importado desde ODK Central. Solo se eliminará de la base de datos de esta aplicación, pero permanecerá en el servidor ODK Central."
        },
        "regular": {
          "title": "Eliminar proyecto",
          "message": "¿Está seguro de que desea eliminar el proyecto \"{name}\"?\n\nADVERTENCIA: Esto eliminará permanentemente el proyecto de la base de datos de esta aplicación y del servidor ODK Central.",
          "messageWithStats": "¿Está seguro de que desea eliminar el proyecto \"{name}\"?\n\nEste proyecto contiene {formsCount} formularios y {submissionsCount} envíos.\nEl proyecto se archivará/ocultará (soft-delete), y los datos se conservarán."
        },
        "confirmButton": "Eliminar"
      }
    },
    "notifications": {
      "organizationNotSelected": "Organización no seleccionada"
    },
    "import": {
      "title": "Importar Proyectos ODK",
      "subtitle": "Cargue proyectos ODK existentes del servidor de la organización y cárguelos en este espacio de trabajo.",
      "selectServer": "Seleccionar Servidor ODK",
      "getProjects": "Obtener Proyectos",
      "availableProjects": "Proyectos Disponibles",
      "noProjectsFound": "No se encontraron proyectos en el servidor seleccionado.",
      "importProject": "Importar",
      "imported": "Importado",
      "errors": {
        "serversLoadFailed": "No se pudieron cargar los servidores ODK. Por favor, inténtelo más tarde.",
        "projectsLoadFailed": "No se pudieron cargar los proyectos del servidor ODK. Por favor, verifique la conexión e inténtelo de nuevo.",
        "importFailed": "No se pudo importar el proyecto. Por favor, inténtelo más tarde.",
        "importError": "Error al importar el proyecto: {detail}"
      }
    },
    "importForms": {
      "title": "Importar Formularios ODK",
      "subtitle": "Seleccione formularios de su proyecto ODK Central para añadirlos aquí.",
      "subtitleWithProject": "Seleccione formularios del proyecto Central {odkProjectId} para añadirlos a {name}.",
      "loadingForms": "Cargando formularios del servidor ODK...",
      "availableForms": "Formularios Disponibles",
      "searchForms": "Buscar formularios...",
      "selectAll": "Seleccionar Todo",
      "deselectAll": "Deseleccionar Todo",
      "importSelected": "Importar Seleccionados",
      "noFormsFound": "No se encontraron formularios para este proyecto en el servidor ODK.",
      "errors": {
        "projectNotLinked": "El proyecto no está vinculado a un servidor ODK",
        "formsLoadFailed": "No se pudieron cargar los formularios del servidor ODK. Por favor, inténtelo más tarde.",
        "formsLoadError": "Error al cargar formularios: {detail}",
        "importFailed": "No se pudieron importar los formularios. Por favor, inténtelo más tarde.",
        "importError": "Error de importación: {detail}"
      },
      "status": {
        "imported": "Importado",
        "available": "Disponible"
      },
      "progress": {
        "started": "Importación iniciada",
        "completedSummary": "Los formularios están listos en este proyecto.",
        "failedSummary": "No se pudieron importar algunos formularios. Revise los detalles a continuación.",
        "viewProject": "Ver proyecto",
        "forms": "{done} / {total} formularios",
        "submissions": "{count} envíos procesados",
        "submissionsProgress": "{fetched} / {total} envíos sincronizados",
        "stages": {
          "queued": "En espera de inicio",
          "pending": "En espera de inicio",
          "importingForms": "Importando formularios",
          "syncingData": "Sincronizando datos"
        },
        "messages": {
          "queued": "La tarea se ha puesto en cola y está esperando inicio...",
          "importingForms": "Importando metadatos de formularios..."
        }
      }
    },
    "detail": {
      "loading": "Cargando proyecto...",
      "returnToProjects": "Volver a proyectos",
      "forms": {
        "title": "Formularios del proyecto",
        "noForms": "El proyecto no tiene formularios.",
        "contactAdmin": "Contacte al administrador para agregar formularios.",
        "actions": {
          "publish": "Publicar",
          "abandon": "Abandonar",
          "attachments": "Adjuntos",
          "qrCode": "Código QR para pruebas",
          "previewEnketo": "Vista previa en Enketo",
          "downloadTestData": "Descargar datos de prueba",
          "formSettings": "Configuración del formulario",
          "viewDetails": "Ver/Detalles",
          "changeState": "Cambiar estado",
          "delete": "Eliminar/Abandonar"
        },
        "modals": {
          "qrCode": {
            "title": "Código QR para pruebas",
            "description": "Escanee el código QR para probar el formulario"
          },
          "formSettings": {
            "title": "Configuración del formulario",
            "basicSettings": "Configuración básica (Placeholder)",
            "accessSettings": "Configuración de acceso (Placeholder)",
            "placeholder": "Esta es una interfaz de demostración. La funcionalidad está en desarrollo."
          }
        },
        "messages": {
          "tryAgain": "Intentar de nuevo",
          "publishing": "Publicando formulario {name}...",
          "published": "Formulario {name} publicado exitosamente",
          "previewing": "Vista previa de {name} en Enketo (dev placeholder)",
          "downloading": "Descargando datos de prueba para {name} (dev placeholder)",
          "saving": "Guardando configuración para {name} (dev placeholder)",
          "missingData": "Faltan datos para importar formularios",
          "missingXlsformData": "Faltan datos para cargar XLSForm",
          "noAttachments": "El formulario no tiene archivos adjuntos"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "Servidores ODK",
    "subtitle": "Gestione los servidores ODK de la organización, sus configuraciones, visibilidad y estado de conexión.",
    "addServer": "Agregar servidor",
    "editServer": "Editar servidor",
    "deleteServer": "Eliminar servidor",
    "modal": {
      "addSubtitle": "Conecte un servidor ODK Central a esta organización.",
      "editSubtitle": "Actualice la configuración de conexión del servidor."
    },
    "table": {
      "default": "Por defecto",
      "visibility": "Visibilidad",
      "setAsDefault": "Establecer como predeterminado",
      "setAsDefaultTooltip": "Establecer como servidor predeterminado para esta organización",
      "testConnection": "Probar conexión",
      "testConnectionTooltip": "Probar conexión al servidor ODK Central",
      "testConnectionDisabled": "La prueba de conexión está disponible solo para servidores que pertenecen a la organización",
      "editServer": "Editar servidor",
      "editServerTooltip": "Editar detalles del servidor (solo para servidores ORGANIZACIÓN y con permisos)",
      "deleteServer": "Eliminar servidor",
      "deleteServerTooltip": "Eliminar servidor (solo para servidores ORGANIZACIÓN y con permisos)",
      "odkSession": "Sesión ODK"
    },
    "session": {
      "banner": "Uno o más servidores tienen una sesión de ODK Central que caduca o no es válida, o no hay contraseña guardada. Edite el servidor y guarde la contraseña para que la aplicación pueda volver a conectarse automáticamente.",
      "ok": "Sesión correcta",
      "expiresSoon": "Caduca pronto",
      "expired": "Caducada",
      "unknown": "Desconocido",
      "noStoredPassword": "Sin contraseña guardada"
    },
    "form": {
      "serverName": "Nombre del servidor",
      "serverUrl": "URL del servidor",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Nombre de usuario",
      "password": "Contraseña",
      "passwordPlaceholderEdit": "Dejar vacío para no cambiar",
      "description": "Descripción",
      "serverIsActive": "Servidor activo",
      "serverIsActiveHint": "Los servidores inactivos permanecen en la lista pero no se ofrecen al crear proyectos."
    },
    "validation": {
      "serverNameRequired": "El nombre del servidor es obligatorio",
      "serverUrlRequired": "La URL del servidor es obligatoria",
      "urlFormatInvalid": "La URL debe comenzar con http:// o https://",
      "usernameRequired": "El nombre de usuario es obligatorio",
      "passwordRequired": "La contraseña es obligatoria"
    },
    "messages": {
      "selectOrganizationFirst": "Por favor, seleccione o cree una organización primero",
      "loadingServers": "Cargando servidores...",
      "noServersFound": "No se encontraron servidores ODK para esta organización",
      "failedToLoadServers": "Error al cargar servidores",
      "noServers": "No hay servidores ODK",
      "serverSaved": "Servidor \"{name}\" {action} exitosamente!",
      "serverSetAsDefault": "Servidor \"{name}\" establecido como predeterminado",
      "connectionTestSuccess": "Conexión correcta. Proyectos encontrados: {count}",
      "connectionTestFailed": "La prueba de conexión falló"
    },
    "contextHint": "Conecte su servidor ODK antes de sincronizar o importar formularios."
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "less": "Ver menos notificaciones"
  },
  "language": {
    "label": "Idioma",
    "english": "Inglés",
    "spanish": "Español",
    "french": "Francés",
    "swahili": "Swahili",
    "portuguese": "Portugués",
    "ukrainian": "Ucraniano",
    "russian": "Ruso",
    "turkish": "Turco"
  },
  "auth": {
    "createAccount": "Crear cuenta",
    "dontHaveAccount": "¿No tienes una cuenta?",
    "email": "Correo electrónico",
    "emailInvalid": "El correo electrónico debe ser válido",
    "emailRequired": "El campo de correo electrónico es obligatorio",
    "enterEmail": "Introduce tu correo electrónico",
    "enterVerificationCode": "Por favor, introduce el código de verificación",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "forgotPasswordDescription": "Si has olvidado tu contraseña, no te preocupes. Simplemente introduce tu dirección de correo electrónico a continuación, y te enviaremos un correo electrónico con instrucciones para restablecer tu contraseña. Restaurar el acceso a tu cuenta nunca ha sido tan fácil.",
    "fullName": "Nombre completo",
    "fullNameRequired": "El campo de nombre completo es obligatorio",
    "goBack": "Volver",
    "haveAccount": "¿Ya tienes una cuenta?",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "passwordMustContainLetter": "La contraseña debe contener al menos una letra",
    "passwordMustContainNumber": "La contraseña debe contener al menos un número",
    "passwordMustContainSpecial": "La contraseña debe contener al menos un carácter especial",
    "passwordMustBe8Chars": "La contraseña debe tener al menos 8 caracteres",
    "passwordRequired": "El campo de contraseña es obligatorio",
    "passwordRequirements": "La contraseña debe tener 8+ caracteres: letras, números y caracteres especiales.",
    "passwordsDontMatch": "Las contraseñas no coinciden",
    "registrationFailed": "El registro falló. Por favor, inténtalo de nuevo.",
    "registrationSuccess": "¡Te has registrado exitosamente! Por favor, revisa tu correo electrónico para las instrucciones de activación.",
    "repeatPassword": "Repetir contraseña",
    "repeatPasswordRequired": "El campo de repetir contraseña es obligatorio",
    "resetInstructionsSent": "Las instrucciones de restablecimiento de contraseña han sido enviadas a tu correo electrónico.",
    "resetInstructionsFailed": "No se pudo enviar el correo electrónico de restablecimiento de contraseña. Por favor, inténtalo de nuevo.",
    "resetPassword": "Restablecer contraseña",
    "sendResetInstructions": "Enviar instrucciones de restablecimiento",
    "signUp": "Registrarse",
    "twoFactorAuthentication": "Autenticación de dos factores",
    "verificationCode": "Código de verificación",
    "verificationCodeRequired": "El código de verificación es obligatorio",
    "verifyCode": "Verificar código"
  },
  "dashboard": {
    "subtitle": "Página de inicio con visualizaciones estadísticas y información importante.",
    "activeFormsTitle": "Formularios Activos",
    "activeFormsSubtitle": "Número y estado de formularios activos.",
    "noActiveForms": "No hay formularios activos"
  },
  "qr": {
    "title": "Código QR (configuración ODK Collect)",
    "titleShort": "Código QR",
    "qrName": "Nombre del código QR",
    "projectSection": "Proyecto",
    "projectName": "Nombre del proyecto",
    "projectIcon": "Icono del proyecto",
    "projectColor": "Color del proyecto",
    "generalSection": "Configuración general",
    "serverUrl": "URL del servidor",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "adminSection": "Configuración de administrador",
    "admin": {
      "edit_saved": "Editar guardado",
      "send_finalized": "Enviar finalizado",
      "view_sent": "Ver enviado",
      "password": "Contraseña de administrador",
      "advanced": "Administrador avanzado",
      "getBlank": "Obtener en blanco",
      "deleteSaved": "Eliminar guardado",
      "qrCodeScanner": "Escáner de código QR",
      "changeServer": "Cambiar servidor",
      "changeAppTheme": "Cambiar tema de la app",
      "changeAppLanguage": "Cambiar idioma de la app",
      "changeFontSize": "Cambiar tamaño de fuente",
      "changeNavigation": "Cambiar navegación",
      "maps": "Mapas",
      "periodicUpdates": "Actualizaciones periódicas",
      "automaticUpdate": "Actualización automática",
      "hideOldVersions": "Ocultar versiones antiguas",
      "changeAutosend": "Cambiar envío automático",
      "deleteAfterSend": "Eliminar después de enviar",
      "defaultToFinalized": "Por defecto finalizado",
      "changeConstraintBehavior": "Cambiar comportamiento de restricciones",
      "highResolution": "Alta resolución",
      "imageSize": "Tamaño de imagen",
      "guidanceHint": "Sugerencia de guía",
      "externalAppRecording": "Grabación con app externa",
      "instanceFormSync": "Sincronización de instancias del formulario",
      "changeFormMetadata": "Cambiar metadatos del formulario",
      "analytics": "Análisis",
      "movingBackwards": "Retroceder",
      "accessSettings": "Acceso a configuración",
      "changeLanguage": "Cambiar idioma",
      "jumpTo": "Ir a",
      "saveMid": "Guardar intermedio",
      "saveAs": "Guardar como",
      "markAsFinalized": "Marcar como finalizado"
    },
    "actions": {
      "generate": "Generar QR",
      "downloadPng": "Descargar PNG",
      "copyBase64": "Copiar Base64",
      "reset": "Restablecer",
      "importJson": "Importar JSON"
    },
    "placeholder": "Genere el código QR para verlo aquí",
    "note": "El código contiene Base64 comprimido con zlib de JSON con general/admin/project. La autenticación App User está en server_url.",
    "general": {
      "theme": "Tema",
      "language": "Idioma",
      "fontSize": "Tamaño de fuente",
      "navigation": "Navegación",
      "constraintBehavior": "Comportamiento de restricciones",
      "advanced": "General avanzado",
      "formlistUrl": "URL de lista de formularios",
      "submissionUrl": "URL de envío",
      "periodicUpdates": "Actualizaciones periódicas",
      "deleteAfterSend": "Eliminar después de enviar",
      "defaultCompleted": "Completado por defecto",
      "externalAppRecording": "Grabación con app externa"
    },
    "formManagement": {
      "title": "Gestión de formularios",
      "updateMode": "Modo de actualización",
      "autosend": "Envío automático",
      "imageSize": "Tamaño de imagen",
      "automaticUpdate": "Actualización automática",
      "hideOldVersions": "Ocultar versiones antiguas",
      "instanceSync": "Sincronización de instancias",
      "guidanceHint": "Sugerencia de guía",
      "highResolution": "Alta resolución"
    },
    "maps": {
      "title": "Mapas",
      "basemap": "Mapa base",
      "googleStyle": "Estilo Google",
      "mapboxStyle": "Estilo Mapbox",
      "usgsStyle": "Estilo USGS",
      "cartoStyle": "Estilo CARTO",
      "referenceLayer": "Capa de referencia (ruta)"
    },
    "identity": {
      "title": "Identidad",
      "analytics": "Análisis",
      "userName": "Nombre de usuario",
      "email": "Correo electrónico",
      "phone": "Teléfono"
    },
    "presets": {
      "title": "Plantillas de QR",
      "save": "Guardar plantilla",
      "load": "Cargar plantilla...",
      "delete": "Eliminar",
      "defaultName": "Plantilla {number}"
    },
    "preview": {
      "title": "Vista previa JSON",
      "reset": "Restablecer",
      "import": "Importar"
    },
    "history": {
      "title": "Códigos QR generados",
      "viewAll": "Ver todo",
      "view": "Ver",
      "download": "Descargar",
      "copy": "Copiar",
      "delete": "Eliminar",
      "more": "... y {count} más"
    },
    "placeholders": {
      "qrName": "QR de mi dispositivo",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Equipo de campo"
    },
    "options": {
      "default": "Por defecto",
      "system": "Sistema"
    },
    "messages": {
      "nameRequiredForPreset": "Introduzca un nombre para la plantilla",
      "nameRequiredForAppUser": "El nombre del código QR es obligatorio para crear el usuario de la app",
      "invalidSettings": "Configuración no válida",
      "generateError": "Error al generar el QR y crear el usuario de la app",
      "invalidJsonStructure": "Estructura JSON no válida. Debe contener las secciones project, general y admin.",
      "invalidJsonFormat": "Formato JSON no válido",
      "copyBase64Error": "Error al copiar Base64",
      "projectNameRequired": "El nombre del proyecto es obligatorio",
      "serverRequired": "La URL del servidor es obligatoria",
      "missingOdkProject": "Este proyecto no tiene id de proyecto ODK Central. Reimporte o revise la configuración.",
      "generateSuccess": "QR generado y App User creado",
      "presetSaved": "Plantilla guardada",
      "base64Copied": "Base64 copiado",
      "jsonImported": "Configuración importada desde JSON"
    },
    "workbench": {
      "contextHint": "Cree un QR de ODK Collect con el token de App User en la URL del servidor.",
      "serverReady": "Servidor listo",
      "essentialsTitle": "Configurar",
      "essentialsDesc": "Nombre el QR y la tarjeta Collect, elija icono y color, luego genere.",
      "nameHint": "También se usa como nombre visible del App User en ODK Central.",
      "serverHint": "Tomado del servidor ODK vinculado al proyecto. Al generar se inserta /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Opciones avanzadas de Collect",
      "advancedHint": "Tema, sincronización, mapas — opcional",
      "previewTitle": "Vista previa",
      "previewDesc": "Escanee con ODK Collect después de generar.",
      "libraryHint": "Guardado en este navegador para este proyecto.",
      "libraryEmpty": "Aún no hay códigos QR. Genere uno para empezar.",
      "libraryCount": "{count} en la biblioteca",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: no vinculado — revise el servidor ODK del proyecto",
      "projectNameHint": "Etiqueta en ODK Collect para esta configuración (no el nombre del proyecto en udacapi).",
      "iconHint": "Se muestra en la tarjeta del proyecto en Collect. El valor por defecto suele bastar.",
      "changeIcon": "Cambiar icono",
      "iconDialogTitle": "Icono del proyecto Collect",
      "iconDialogSubtitle": "Elija un glifo para la tarjeta del proyecto en el dispositivo.",
      "applyIcon": "Usar icono"
    },
    "formAccess": {
      "title": "Formularios a los que este recolector puede acceder",
      "hint": "Seleccione al menos un formulario publicado. Sin esto, Collect muestra una lista vacía.",
      "selectAll": "Seleccionar todo",
      "clear": "Borrar",
      "required": "Seleccione al menos un formulario",
      "assignFailed": "No se pudieron asignar formularios al App User",
      "manageAll": "Gestionar todo el acceso a formularios",
      "formsCount": "{n} formularios",
      "noPublishedForms": "Aún no hay formularios publicados en este proyecto."
    }
  },
  "forms": {
    "state": {
      "open": "Abierto",
      "closing": "Cerrando",
      "closed": "Cerrado",
      "draft": "Borrador"
    },
    "deleteConfirm": {
      "title": "Eliminar formulario",
      "subtitle": "Revise las consecuencias antes de eliminar permanentemente este formulario.",
      "message": "Esta acción no se puede deshacer.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Eliminar permanentemente",
      "importedWarning": "Este formulario fue importado desde ODK Central. Se eliminará solo de la base de datos de esta aplicación y permanecerá en el servidor ODK Central.",
      "regularWarning": "Esta acción mueve el formulario a la papelera de ODK Central y lo marca como eliminado localmente.",
      "consequenceDataLoss": "Todas las respuestas y el historial de exportación de este formulario se eliminarán de esta aplicación.",
      "irreversible": "Esta acción no puede ser revertida a través de la interfaz.",
      "success": "Formulario {name} eliminado.",
      "successImported": "Formulario {name} eliminado solo de la base de datos de esta aplicación.",
      "error": "Error al eliminar el formulario: {error}"
    },
    "uploadXlsform": {
      "title": "Cargar XLSForm",
      "subtitle": "Seleccione un libro (.xlsx o .xls, hasta 50 MB) para crear o actualizar un formulario.",
      "selectFile": "Seleccionar archivo XLSForm",
      "dropFileTitle": "Suelte su libro XLSForm aquí",
      "supportedFormats": "Formatos aceptados: .xlsx y .xls, hasta 50 MB.",
      "replaceFileHint": "Elija otro archivo para reemplazar la selección actual.",
      "chooseFile": "Examinar archivos",
      "selectedFile": "Archivo seleccionado:",
      "formSettings": "Identificador del formulario",
      "uploadOptions": "Opciones de carga",
      "formId": "ID del formulario",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "ID del formulario único (solo letras, números y guiones bajos)",
      "formIdWarning": {
        "title": "Importante!",
        "message": "El ID del formulario se extraerá automáticamente del archivo XLSForm ('settings' hoja). Este campo se utiliza solo como opción de respaldo."
      },
      "updateExisting": "Actualizar formulario existente",
      "updateExistingHint": "Si un formulario con este ID ya existe, se actualizará",
      "ignoreWarnings": "Ignorar advertencias",
      "ignoreWarningsHint": "Ignorar advertencias durante la conversión",
      "publishImmediately": "Publicar formulario inmediatamente",
      "publishImmediatelyHint": "Publicar el formulario inmediatamente",
      "uploadButton": "Cargar XLSForm",
      "uploading": "Cargando...",
      "noFileSelected": "Por favor seleccione un archivo para cargar",
      "noFormId": "Por favor ingrese el ID del formulario",
      "uploadingMessage": "Cargando XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" cargado exitosamente!",
      "errorMessage": "Error al cargar: {error}",
      "errorFallback": "No se pudo cargar el archivo. Inténtelo de nuevo.",
      "listUpdated": "XLSForm cargado exitosamente! Lista actualizada."
    },
    "formDetail": {
      "loading": "Cargando formulario...",
      "formLabel": "Formulario",
      "returnToProjects": "Volver a la lista de proyectos",
      "sectionShell": {
        "unknownForm": "Formulario desconocido",
        "loading": "Cargando...",
        "retry": "Reintentar",
        "comingSoonTitle": "Próximamente",
        "comingSoonDescription": "Esta funcionalidad está en desarrollo. Use otras herramientas de formulario en el medio tiempo."
      },
      "sections": {
        "dashboard": {
          "title": "Vista General del Formulario",
          "description": "Estadísticas e información sobre el formulario y datos recopilados"
        },
        "autoReports": {
          "title": "Informes automáticos",
          "description": "Informes de IA programados y bajo demanda que cubren este formulario",
          "contextHint": "Programación, entrega y ejecución bajo demanda para plantillas que cubren este formulario",
          "manageTemplates": "Gestionar plantillas",
          "analysisWindow": "Ventana de análisis",
          "empty": "Ningún informe automático cubre este formulario",
          "emptyHint": "Los propietarios pueden crear plantillas por defecto o asignar formularios",
          "seed": "Crear plantillas por defecto",
          "loadError": "No se pudieron cargar los informes automáticos",
          "scope": {
            "all": "Todos los formularios",
            "this": "Este formulario",
            "many": "{count} formularios"
          },
          "delivery": {
            "email": "Email · {count} destinatarios",
            "inApp": "Solo en la app"
          },
          "manualOnly": "Solo manual",
          "lastRun": "Última ejecución",
          "noLastRun": "Aún sin ejecuciones",
          "generate": "Generar",
          "generateNow": "Generar",
          "viewLatest": "Ver último",
          "generating": "Generando informe…",
          "started": "Informe iniciado",
          "ribbonManual": "Sin programación · {timezone}",
          "sendToRecipients": "Enviar a {n} destinatarios",
          "sent": "Enviado",
          "sentToast": "Enviado a {n} destinatarios",
          "sendFailed": "No se pudo enviar el informe",
          "noRecipientsHint": "Añada destinatarios en Gestionar plantillas para enviar este informe por email"
        },
        "qc": {
          "title": "Control de Calidad",
          "description": "Monitorear y validar la calidad de los datos usando reglas QC",
          "workbench": {
            "contextHint": "Defina reglas, valide envíos y revise problemas señalados para este formulario.",
            "rulesCount": "{count} reglas",
            "activeCount": "{count} activas",
            "validationsCount": "{count} validaciones",
            "summaryTitle": "Vista general de reglas",
            "selectedCount": "{count} seleccionadas",
            "createRuleHint": "Defina una nueva regla de validación para este formulario",
            "editRuleHint": "Actualice la configuración y expresión de la regla",
            "backToRules": "Volver a reglas",
            "pipeline": {
              "ariaLabel": "Flujo de trabajo de validación QC",
              "define": "Definir reglas",
              "defineHint": "{count} reglas configuradas",
              "defineEmpty": "No hay reglas aún: cree su primera verificación",
              "validate": "Validar datos",
              "validateHint": "{count} envíos verificados",
              "validateEmpty": "Ejecute validación en los envíos entrantes",
              "review": "Revisar problemas",
              "reviewHint": "{count} problemas abiertos",
              "reviewClear": "No hay problemas sin resolver"
            }
          }
        },
        "dataExport": {
          "title": "Exportación de datos",
          "description": "Exportar datos del formulario en varios formatos"
        },
        "odkExport": {
          "title": "Exportación de datos",
          "description": "Exportar datos del formulario en varios formatos para su análisis",
          "unknownForm": "Formulario desconocido",
          "exportsCount": "{count} exportaciones",
          "loadingOptions": "Cargando opciones de exportación...",
          "retry": "Reintentar",
          "infoSubtitleDetailed": "Seleccione los formatos de exportación y configure las opciones para descargar los datos de su formulario.",
          "formatsAvailable": "{count} formatos disponibles",
          "formatsTitle": "Formatos de exportación",
          "selectFormats": "Seleccione uno o más formatos para exportar",
          "statisticalFormatsTitle": "Formatos estadísticos",
          "geoFormatsTitle": "Formatos geográficos",
          "noGeoData": "No se encontraron datos geográficos en este formulario",
          "configTitle": "Configuración de la exportación",
          "configSubtitle": "Configure las opciones de exportación y los filtros",
          "dataOptions": "Opciones de datos",
          "includeRepeats": "Incluir grupos de repetición",
          "includeLabels": "Incluir etiquetas de campo",
          "includeMetadata": "Incluir metadatos",
          "labelLanguage": "Idioma de la etiqueta",
          "selectLanguage": "Seleccionar idioma",
          "loadingLanguages": "Cargando idiomas...",
          "generatingLabels": "Generando etiquetas...",
          "noLabelsAvailable": "No hay etiquetas disponibles. Haga clic en actualizar para generar etiquetas.",
          "filters": "Filtros",
          "dateRange": "Rango de fechas",
          "startDate": "Fecha de inicio",
          "endDate": "Fecha de finalización",
          "dataFilter": "Filtro de datos",
          "dataFilterPlaceholder": "ej. edad > 18",
          "readyToExport": "Listo para exportar",
          "readyToExportSubtitle": "Haga clic en el botón para iniciar el proceso de exportación",
          "labelsRequiredNotice": "Las etiquetas son necesarias pero no están disponibles. Por favor, genere las etiquetas primero.",
          "activeExports": "Exportaciones activas",
          "exportButton": "Exportar datos",
          "historyTitle": "Historial de exportaciones",
          "historySubtitle": "Ver y descargar exportaciones anteriores",
          "refresh": "Actualizar",
          "loadingHistory": "Cargando historial...",
          "noHistory": "Aún no hay exportaciones",
          "noHistoryDesc": "Comience exportando datos en su formato preferido.",
          "workbench": {
            "contextHint": "Seleccione formatos y opciones, luego ejecute la exportación.",
            "geoAvailable": "Datos geográficos disponibles",
            "geoUnavailable": "No hay datos geográficos",
            "optionsTitle": "Opciones",
            "refreshLabels": "Actualizar etiquetas",
            "labelsGenerated": "Etiquetas generadas ({count} idiomas)",
            "exportButtonOne": "Exportar 1 formato",
            "exportButtonMany": "Exportar {count} formatos",
            "selectFormatHint": "Seleccione al menos un formato para exportar.",
            "readySummaryOne": "1 formato listo para exportar.",
            "readySummaryMany": "{count} formatos listos para exportar.",
            "jobsTitle": "Trabajos",
            "jobsSubtitle": "Seguimiento de exportaciones activas y descarga de archivos anteriores.",
            "noActiveJobs": "No hay exportaciones activas.",
            "noHistoryAction": "Seleccione un formato arriba y ejecute la exportación.",
            "pipeline": {
              "sync": "Sincronizar datos",
              "convert": "Convertir",
              "ready": "Listo"
            }
          },
          "date": "Fecha",
          "format": "Formato",
          "records": "Registros",
          "size": "Tamaño",
          "user": "Usuario",
          "actions": "Acciones",
          "download": "Descargar",
          "viewError": "Ver error",
          "errorDetails": "Detalles del error",
          "errorSubtitle": "Información del error de ejecución de la exportación",
          "close": "Cerrar",
          "deleteTitle": "Eliminar exportación",
          "deleteSubtitle": "Esta acción no se puede deshacer",
          "deleteConfirm": "¿Está seguro de que desea eliminar la exportación del {date}? Esta acción no se puede deshacer.",
          "cancel": "Cancelar",
          "delete": "Eliminar",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Todos los datos",
            "last30": "Últimos 30 días",
            "last90": "Últimos 90 días",
            "thisyear": "Este año",
            "lastyear": "El año pasado",
            "custom": "Rango personalizado"
          },
          "status": {
            "odataSyncError": "Error de comprobación de sincronización de OData: {error}",
            "localDataMissing": "Faltan datos locales, descargando OData...",
            "odataStatusError": "Error de estado de OData",
            "downloadingOdata": "Descargando OData...",
            "downloadSuccessCount": "{count} envíos descargados",
            "downloadError": "Error de descarga de OData: {error}",
            "geoRequired": "{format} requiere datos geográficos"
          },
          "notifications": {
            "selectFormat": "Por favor, seleccione al menos un formato",
            "startingDownload": "Iniciando descarga...",
            "downloadSuccess": "Archivo descargado con éxito",
            "downloadError": "Error de descarga: {error}",
            "taskIdMissing": "No se puede descargar: falta el ID de la tarea",
            "exportDeleted": "Exportación eliminada con éxito",
            "exportCompleted": "Exportación {format} completada",
            "exportFailed": "Exportación {format} fallida",
            "trackingError": "Error de seguimiento: {error}",
            "noErrorDetails": "No hay detalles de error disponibles",
            "currentUser": "Usuario actual"
          }
        },
        "dataAnalysis": {
          "title": "Análisis de datos",
          "description": "Construye tablas dinámicas para análisis ad hoc y guarda vistas en monitoreo",
          "recordsLoaded": "{count} registros cargados",
          "variablesSelected": "{count} variables seleccionadas",
          "tablesAvailable": "{count} tablas disponibles",
          "workbench": {
            "contextHint": "Selecciona variables, explora con una tabla pivot, luego guarda una vista en monitoreo",
            "loadingData": "Cargando datos...",
            "pipeline": {
              "ariaLabel": "Workflow de análisis",
              "source": "Origen de datos",
              "sourceHint": "{table}",
              "sourceEmpty": "Selecciona una tabla de datos",
              "variables": "Variables",
              "variablesHint": "{count} seleccionadas",
              "variablesEmpty": "Selecciona campos para analizar",
              "pivot": "Tabla dinámica",
              "pivotHint": "{count} registros cargados",
              "pivotEmpty": "Carga datos para explorar",
              "pivotLoading": "Cargando registros...",
              "save": "Guardar vista",
              "saveHint": "Listo para guardar en monitoreo",
              "saveEmpty": "Configura la tabla dinámica primero"
            },
            "source": {
              "title": "Origen de datos",
              "subtitle": "Selecciona qué tabla de envío y cómo se muestran los valores",
              "labelsMissing": "No se generan etiquetas para este formulario",
              "labelsMissingHint": "Genera etiquetas desde el XLSForm para mostrar nombres de variables y etiquetas de valores.",
              "generateLabels": "Generar etiquetas",
              "table": "Tabla de datos",
              "tablePlaceholder": "Selecciona una tabla de datos",
              "displayOptions": "Opciones de visualización",
              "showLabels": "Mostrar etiquetas",
              "language": "Idioma",
              "includeMetadata": "Incluir metadatos"
            },
            "variables": {
              "title": "Variables",
              "selectedCount": "{count} seleccionadas",
              "selectTableFirst": "Selecciona una tabla de datos para ver las variables disponibles.",
              "selectAll": "Seleccionar todos",
              "clearAll": "Borrar todos",
              "searchPlaceholder": "Buscar variables...",
              "empty": "No hay variables que coincidan con tu búsqueda",
              "moreCount": "+{count} más",
              "loading": "Cargando...",
              "loadCta": "Cargar {count} variables"
            },
            "pivot": {
              "title": "Tabla dinámica",
              "subtitle": "Arrastra campos a filas, columnas o valores para construir tu vista",
              "hint": "Arrastra variables a filas, columnas o valores. Cuando el diseño parece correcto, guárdala como una tabla de monitoreo.",
              "reprocess": "Reprocesar análisis",
              "saveCta": "Guardar en monitoreo",
              "analyticsProcessed": "{percent}% procesado"
            },
            "empty": {
              "title": "Selecciona variables",
              "hint": "Selecciona una o más variables de la tabla seleccionada para iniciar tu análisis."
            },
            "save": {
              "title": "Guardar tabla de monitoreo",
              "subtitle": "Dale a esta vista dinámica un nombre para que puedas encontrarlo en la página de monitoreo.",
              "tableName": "Nombre de la tabla",
              "tableNamePlaceholder": "Ingrese el nombre de la tabla",
              "description": "Descripción",
              "descriptionPlaceholder": "¿Qué rastrea esta tabla?",
              "summary": "Resumen de análisis",
              "variables": "Variables",
              "table": "Tabla",
              "cancel": "Cancelar",
              "confirm": "Guardar tabla"
            },
            "toasts": {
              "labelsGenerated": "Etiquetas generadas. Recargando variables...",
              "labelsFailed": "No se pudieron generar etiquetas. Verifique que el XLSForm está disponible.",
              "saveSuccess": "Tabla guardada. Abra Data Monitoring para verla.",
              "saveFailed": "No se pudo guardar la tabla. Intente nuevamente o contacte al soporte.",
              "formIdMissing": "Form ID no encontrado",
              "reprocessSuccess": "Análisis reprocesado: {count} nuevos registros",
              "reprocessFailed": "Análisis reprocesado fallido",
              "reprocessError": "Error de reprocesamiento de análisis: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Monitoreo de datos",
          "description": "Ver tablas de monitoreo guardadas con actualizaciones en tiempo real",
          "tablesCount": "{count} tablas",
          "updating": "Actualizando...",
          "workbench": {
            "contextHint": "Vista dinámica guardada con actualización de datos en tiempo real mientras esta página está abierta",
            "activeViewsCount": "{count} activas",
            "liveStrip": {
              "ariaLabel": "Estado de monitoreo",
              "saved": "Tablas guardadas",
              "savedHint": "{count} tablas listas",
              "savedEmpty": "No hay tablas guardadas todavía",
              "watch": "Vista activa",
              "watchHint": "Viendo {title}",
              "watchEmpty": "Selecciona una tabla para ver",
              "watchDisabled": "Crea una tabla primero",
              "sync": "Sincronización en vivo",
              "syncHint": "Actualiza cada 30 segundos",
              "syncActive": "Actualizando ahora..."
            },
            "displayOptions": {
              "title": "Opciones de visualización",
              "subtitle": "Controla cómo aparecen los nombres de las variables en las tablas pivot",
              "showLabels": "Mostrar etiquetas",
              "language": "Idioma"
            },
            "summary": {
              "title": "En un vistazo",
              "tables": "Tablas guardadas",
              "activeView": "Vista activa",
              "records": "Registros en vista",
              "refreshInterval": "Actualización automática"
            },
            "tables": {
              "title": "Tablas de monitoreo",
              "subtitle": "Vista dinámica guardada desde análisis de datos",
              "loading": "Cargando tablas de monitoreo...",
              "emptyTitle": "No hay tablas de monitoreo todavía",
              "emptyHint": "Crea una tabla pivot en la página de análisis y guárdala aquí.",
              "createCta": "Ir a análisis",
              "realtimeHint": "Los datos se actualizan cada 30 segundos mientras esta página está abierta. Use Refresh para una actualización inmediata.",
              "records": "{count} registros",
              "lastUpdated": "Última actualización {time}",
              "view": "Ver",
              "hide": "Ocultar",
              "loadingPivot": "Cargando datos de la tabla dinámica...",
              "public": "Público",
              "private": "Privado"
            },
            "delete": {
              "title": "Eliminar tabla",
              "confirm": "¿Eliminar tabla \"{title}\"?",
              "detail": "Esta acción elimina permanentemente la tabla y sus datos en caché.",
              "cancel": "Cancelar",
              "confirmBtn": "Eliminar tabla"
            }
          }
        },
        "settings": {
          "title": "Configuración",
          "description": "Gestiona la configuración del formulario",
          "formStatus": "Estado del formulario",
          "basicSettings": "Configuración básica",
          "notifications": {
            "noChanges": "No hay cambios para guardar",
            "draftWarning": "Los borradores de formularios no se pueden cambiar a través de esta interfaz. Primero publique el formulario.",
            "stateChangeHint": "Cambiar el estado del formulario afecta si se aceptan nuevos envíos.",
            "invalidState": "Estado de formulario inválido: {state}",
            "success": "Estado del formulario cambiado exitosamente a {state}",
            "error": "Error al cambiar el estado del formulario: {error}",
            "errorLog": "Error al cambiar el estado del formulario"
          },
          "version": {
            "title": "Versión",
            "notSpecified": "No especificada",
            "history": "Historial de versiones",
            "noHistory": "No hay historial de versiones disponible",
            "download": "Descargar",
            "restore": "Restaurar",
            "uploadNew": "Cargar nueva versión",
            "author": "Autor"
          },
          "dataCollectors": {
            "title": "Recolectores de datos",
            "description": "Gestionar el acceso de usuarios a la recolección de datos del formulario",
            "noCollectors": "No hay recolectores de datos asignados",
            "addCollector": "Agregar recolector",
            "editCollector": "Editar recolector",
            "removeCollector": "Eliminar recolector",
            "addCollectorModal": {
              "title": "Agregar recolector de datos",
              "placeholder": "Stub: aquí estará el formulario para agregar recolector de datos"
            }
          },
          "publicAccess": {
            "title": "Acceso público",
            "description": "Crear un enlace público para recolección de datos a través de la interfaz web",
            "publicLink": "Enlace público",
            "disable": "Deshabilitar",
            "requireAuth": "Requerir autenticación",
            "collectEmail": "Recopilar correo electrónico",
            "limitSubmissions": "Limitar número de respuestas",
            "maxSubmissions": "Número máximo de respuestas",
            "updateSettings": "Actualizar configuración",
            "createLink": "Crear enlace público",
            "notCreated": "Enlace público no creado. Cree un enlace para recolección de datos a través de la interfaz web.",
            "created": "Enlace público creado",
            "copied": "Enlace copiado al portapapeles",
            "disabled": "Enlace público deshabilitado",
            "updated": "Configuración del enlace público actualizada"
          },
          "qrCodes": {
            "title": "Códigos QR para la recolección de datos",
            "description": "Gestionar códigos QR para configurar dispositivos de recolección de datos para este formulario",
            "assignedTitle": "Códigos QR asignados",
            "availableTitle": "Códigos QR del proyecto disponibles",
            "createNew": "Crear nuevo código QR",
            "noAvailable": "No hay códigos QR disponibles",
            "createInstruction": "Cree un código QR para configurar dispositivos de recolección de datos",
            "manageOnProject": "Los códigos QR de ODK Collect se gestionan a nivel de proyecto (App Users).",
            "openProjectQr": "Abrir códigos QR del proyecto",
            "openFormAccess": "Gestionar acceso a formularios",
            "notifications": {
              "assigned": "Código QR asignado al formulario",
              "unassigned": "Código QR desvinculado del formulario",
              "copied": "Base64 copiado al portapapeles",
              "copyError": "Error al copiar: {error}"
            }
          },
          "attachments": {
            "title": "Adjuntos y Archivos Multimedia",
            "description": "Gestionar archivos y adjuntos asociados con el formulario",
            "xlsformFile": "Archivo XLSForm",
            "xlsformDescription": "Descargar el archivo XLSForm original de este formulario en formato Excel",
            "downloadXlsform": "Descargar XLSForm",
            "manageAttachments": "Gestionar Adjuntos",
            "downloadSuccess": "Archivo XLSForm descargado exitosamente",
            "downloadError": "Error al descargar archivo XLSForm",
            "fileNotFound": "Archivo XLSForm no encontrado para este formulario",
            "accessDenied": "Sin acceso para descargar archivo XLSForm",
            "serverError": "Error del servidor: {status}"
          },
          "analytics": {
            "title": "Gestión de análisis",
            "recreateAnalytics": "Recrear análisis",
            "description": "Recrear datos de análisis para todos los envíos del formulario. Use esto cuando los datos de análisis estén corruptos o falten.",
            "warning": "Esta operación eliminará todos los datos de análisis existentes y los recreará a partir de los datos de envíos originales.",
            "confirmTitle": "Confirmar recreación de análisis",
            "alertTitle": "Advertencia: recreación de datos requerida",
            "alertDescription": "Esta acción eliminará permanentemente todos los datos de análisis existentes y los recreará desde cero.",
            "whatWillHappen": "Qué sucederá:",
            "step1": "Todos los datos de análisis existentes se eliminarán",
            "step2": "Los datos de envíos originales se volverán a procesar",
            "step3": "Se crearán nuevos datos de análisis con formato correcto",
            "step4": "Las tablas dinámicas y las funciones de análisis funcionarán correctamente",
            "timeWarning": "Esta operación puede tardar varios minutos para formularios con muchos envíos.",
            "recreateButton": "Recrear análisis",
            "confirmButton": "Sí, recrear análisis",
            "success": "¡Análisis recreado exitosamente! Se procesaron {processed} envíos, se recrearon {recreated} registros de análisis de {total} envíos totales.",
            "error": "Error al recrear datos de análisis",
            "apiError": "Error de API: {error}"
          },
          "dangerZone": {
            "title": "Zona de peligro",
            "deleteForm": "Eliminar formulario",
            "description": "Esta acción no se puede deshacer. Todos los datos recopilados se perderán.",
            "confirmDelete": "Confirmar eliminación del formulario",
            "confirmMessage": "¿Está seguro de que desea eliminar el formulario \"{name}\"?",
            "confirmDescription": "Esta acción no se puede deshacer. Todos los datos recopilados se perderán.",
            "enterFormName": "Ingrese el nombre del formulario para confirmar",
            "deleteFormButton": "Eliminar formulario",
            "formDeleted": "Formulario eliminado (función stub)"
          }
        },
        "datasets": {
          "title": "Conjuntos de datos",
          "description": "Gestión de conjuntos de datos y entidades"
        }
      },
      "errors": {
        "missingParams": "Faltan parámetros requeridos para cargar el formulario",
        "loadError": "Error al cargar datos del formulario",
        "unknownError": "Error desconocido"
      }
    },
    "dashboard": {
      "loading": "Cargando análisis...",
      "analyticsError": "Error al cargar análisis",
      "retry": "Reintentar carga",
      "workbench": {
        "contextHint": "Identidad del formulario, ingesta, línea de tiempo y AI para un periodo compartido (7 / 30 / all).",
        "completionBadge": "{rate}% de finalización",
        "metaVersion": "v{version}",
        "metaPublished": "pub. {date}",
        "metaUpdated": "act. {date}",
        "summaryTitle": "Resumen de recolección",
        "sections": {
          "metadata": {
            "title": "Identidad de la forma",
            "xmlFormId": "ID XML de la forma",
            "version": "Versión",
            "published": "Publicada",
            "updated": "Última actualización"
          },
          "intake": {
            "title": "Resumen de recolección",
            "subtitle": "Envíos de hoy, esta semana y en total"
          },
          "quickLinks": {
            "title": "Enlaces rápidos"
          },
          "agent": {
            "title": "Asistente IA",
            "subtitle": "Resúmenes, informes analíticos o chat sobre esta forma"
          },
          "timeline": {
            "title": "Línea de tiempo de envíos",
            "subtitle": "Volumen diario de envíos en el período seleccionado"
          },
          "map": {
            "title": "Distribución geográfica",
            "subtitle": "Ubicaciones de envío con datos geo"
          }
        },
        "metrics": {
          "noChange": "Sin cambios"
        },
        "intakeStrip": {
          "ariaLabel": "Estado de recolección de datos",
          "today": "Hoy",
          "todayDelta": "{delta} vs ayer",
          "todayFlat": "Igual que ayer",
          "week": "Esta semana",
          "weekDelta": "{delta} vs semana pasada",
          "weekFlat": "Igual que la semana pasada",
          "total": "Todas las respuestas",
          "totalHint": "Total recopilado para esta forma",
          "totalEmpty": "Aún no hay respuestas"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Total de Envíos",
          "today": "hoy"
        },
        "completedSubmissions": {
          "title": "Envíos Completados",
          "rate": "tasa de finalización"
        },
        "dataCollectors": {
          "title": "Recolectores de Datos",
          "new": "nuevos"
        },
        "problematicSubmissions": {
          "title": "Envíos Problemáticos"
        },
        "submissionTimeline": {
          "title": "Línea de Tiempo de Envíos",
          "totalForPeriod": "Total del período",
          "noData": "No hay datos de línea de tiempo de envíos",
          "noSubmissionsInPeriod": "No hay envíos en el período seleccionado",
          "stats": {
            "totalSubmissions": "Total de envíos",
            "maxPerDay": "Máximo por día",
            "trend": "Tendencia"
          },
          "timeframes": {
            "7days": "Últimos 7 días",
            "30days": "Últimos 30 días",
            "90days": "Últimos 90 días",
            "allFormData": "Todos los datos del formulario"
          },
          "trend": {
            "stable": "Sin cambios",
            "growth": "Crecimiento",
            "decline": "Disminución"
          },
          "hint": "Haz clic en una barra para ver información detallada del día"
        }
      }
    },
    "summaryCard": {},
    "attachments": {
      "title": "Adjuntos del formulario",
      "formLabel": "Formulario:",
      "noAttachmentsRequired": "No se requieren adjuntos",
      "noAttachmentsDescription": "Este formulario no contiene referencias a archivos externos (imágenes, documentos, etc.).",
      "noAttachmentsHint": "Si agrega referencias de archivos en XLSForm, aparecerán automáticamente aquí.",
      "uploadSection": {
        "supportedFormats": "Formatos soportados:",
        "dropZoneTitles": {
          "uploadMissing": "Subir archivos faltantes",
          "updateExisting": "Actualizar archivos existentes",
          "uploadFiles": "Subir archivos"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Se esperan {count} archivo(s): {files}",
          "updateExisting": "Todos los archivos están subidos. Puede reemplazarlos con nuevas versiones.",
          "uploadFiles": "Seleccione archivos para subir adjuntos del formulario."
        },
        "dropZoneButtons": {
          "selectFiles": "Seleccionar archivos",
          "updateFiles": "Actualizar archivos",
          "chooseFiles": "Elegir archivos"
        },
        "selectedFiles": "Archivos seleccionados ({count})",
        "uploadButton": "Subir {count} archivos",
        "uploading": "Subiendo...",
        "clear": "Limpiar",
        "chooseFiles": "Elegir archivos"
      },
      "table": {
        "columns": {
          "name": "Nombre del archivo",
          "status": "Estado",
          "type": "Tipo",
          "size": "Tamaño",
          "updatedAt": "Fecha de subida",
          "actions": "Acciones"
        },
        "status": {
          "uploaded": "Subido",
          "missing": "Faltante",
          "deleted": "Eliminado",
          "unknown": "Desconocido"
        },
        "actions": {
          "download": "Descargar",
          "delete": "Eliminar",
          "deleted": "Eliminado",
          "missing": "Faltante"
        },
        "notSpecified": "No especificado"
      },
      "messages": {
        "uploadSuccess": "Se subieron exitosamente {count} archivos",
        "uploadError": "Error al subir archivos: {error}",
        "fileNotFound": "Archivo {filename} no encontrado en archivos seleccionados",
        "fileUploadSuccess": "Archivo {filename} subido exitosamente",
        "fileUploadError": "Error al subir archivo {filename}: {error}",
        "downloadError": "Error al descargar archivo {filename}: {error}",
        "deleteSuccess": "Archivo {filename} eliminado exitosamente",
        "deleteError": "Error al eliminar archivo {filename}: {error}",
        "invalidFilesIgnored": "Los siguientes archivos serán ignorados (no encontrados en la lista esperada): {files}",
        "filesWillBeUpdated": "Los siguientes archivos serán actualizados: {files}",
        "loadingError": "Error al cargar adjuntos",
        "downloadSuccess": "Archivo {filename} descargado exitosamente",
        "fileAlreadyDeleted": "El archivo {filename} ya fue eliminado o no existe",
        "fileNotInExpectedList": "Archivo no encontrado en la lista de adjuntos esperados"
      },
      "confirmDelete": {
        "title": "Confirmar eliminación",
        "message": "¿Está seguro de que desea eliminar el archivo \"{filename}\"?",
        "warning": "Esta acción no se puede deshacer.",
        "deleting": "Eliminando...",
        "delete": "Eliminar"
      }
    }
  },
  "pageNotFound": {
    "title": "¡Vaya! Página no encontrada.",
    "subtitle": "404",
    "description": "La página que buscas no existe o ha sido movida.",
    "goBack": "Volver",
    "goHome": "Ir a la página principal",
    "copyright": "© {year} UDACAPI. Todos los derechos reservados."
  },
  "maps": {
    "tabTitle": "Mapa",
    "pageTitle": "Mapa del proyecto",
    "subtitle": "Monitorea en tiempo real las entregas con GPS",
    "empty": {
      "noGeoForms": "Ningún formulario de este proyecto tiene preguntas GPS todavía.",
      "noPoints": "Ninguna entrega coincide con los filtros actuales."
    },
    "filters": {
      "title": "Filtros",
      "forms": "Formularios",
      "dateFrom": "Desde",
      "dateTo": "Hasta",
      "qcStatus": "Estado QC",
      "enumerator": "Encuestador",
      "heatmap": "Mapa de calor",
      "reset": "Restablecer filtros",
      "apply": "Aplicar"
    },
    "qcStatuses": {
      "any": "Cualquiera",
      "pass": "Aprobado",
      "fail": "Rechazado",
      "warning": "Advertencia",
      "error": "Error",
      "none": "Sin validar"
    },
    "actions": {
      "export": "Exportar a GeoJSON",
      "refresh": "Actualizar",
      "settings": "Ajustes del mapa",
      "openSubmission": "Abrir entrega",
      "openFormOnMap": "Ver formulario en el mapa"
    },
    "popup": {
      "submittedAt": "Enviado el",
      "submittedBy": "Enviado por",
      "form": "Formulario",
      "status": "Estado QC"
    },
    "truncated": "Mostrando los primeros {limit} puntos. Ajusta los filtros o activa el agrupamiento para ver más.",
    "settingsDialog": {
      "title": "Ajustes del mapa del proyecto",
      "defaultCenter": "Centro predeterminado",
      "defaultCenterHint": "Haz clic en el mapa para elegir una ubicación",
      "defaultZoom": "Zoom predeterminado",
      "defaultForms": "Formularios predeterminados",
      "heatmapDefault": "Mostrar mapa de calor por defecto",
      "coordinateFields": "Campos de coordenadas",
      "latitudeField": "Campo de latitud",
      "longitudeField": "Campo de longitud",
      "automaticDetection": "Usar detección automática",
      "coordinateSourceTitle": "Fuente de coordenadas",
      "coordinateMode": "Modo de coordenadas",
      "modeAuto": "Detección automática",
      "modeNone": "Sin datos de ubicación",
      "modeLatLon": "Campos de latitud y longitud",
      "modeGeopoint": "Campo geopoint",
      "geopointField": "Campo geopoint",
      "detectedSource": "Fuente detectada: {path} · puntos actuales: {count}",
      "configureCoordinates": "Campos de coordenadas",
      "noMapHint": "No hay puntos en el mapa para este formulario. Configure los campos de coordenadas si los envíos contienen ubicaciones.",
      "save": "Guardar",
      "cancel": "Cancelar",
      "saved": "Ajustes guardados"
    },
    "savedViews": {
      "title": "Vistas guardadas",
      "noViewsYet": "No hay vistas guardadas — créalas en el mapa del proyecto",
      "recommended": "Recomendada",
      "defaultLabel": "predeterminada",
      "saveHint": "Tras Aplicar, el mapa usa sus filtros y el mapa de calor. «Guardar vista actual» guarda esta configuración con un nombre (solo gestores del proyecto).",
      "saveCurrent": "Guardar vista actual",
      "updateCurrent": "Actualizar vista",
      "delete": "Eliminar vista",
      "name": "Nombre de la vista",
      "pinAsDefault": "Fijar como predeterminada",
      "pin": "Fijar vista",
      "saved": "Vista guardada",
      "updated": "Vista actualizada",
      "deleted": "Vista eliminada",
      "saveFailed": "No se pudo guardar la vista. Compruebe que la API está desplegada y que las migraciones de la base de datos incluyen project_map_views.",
      "updateFailed": "No se pudo actualizar la vista.",
      "deleteFailed": "No se pudo eliminar la vista."
    },
    "tileConfig": {
      "sectionTitle": "Servidor de teselas del mapa",
      "sectionDescription": "Proporciona una URL de servidor de teselas personalizado para tu organización. Deja en blanco para usar las teselas públicas de OpenStreetMap.",
      "url": "Plantilla de URL de teselas",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Atribución",
      "subdomains": "Subdominios",
      "maxZoom": "Zoom máx.",
      "minZoom": "Zoom mín.",
      "test": "Probar URL",
      "configure": "Configurar",
      "edit": "Editar",
      "defaultTiles": "Usando teselas públicas de OpenStreetMap",
      "zoom": "Zoom",
      "clear": "Borrar",
      "save": "Guardar",
      "saved": "Configuración de teselas guardada",
      "cleared": "Servidor de teselas personalizado borrado"
    }
  },
  "help": {
    "title": "Ayuda",
    "subtitle": "Guías breves y respuestas para tareas habituales de UDACAPI.",
    "searchPlaceholder": "Buscar guías y preguntas…",
    "learnMore": "Más información",
    "openGuide": "Abrir",
    "openGuideFormScope": "Abrir el panel — luego elija un proyecto y un formulario",
    "whenToUse": "Cuándo usar",
    "steps": "Pasos",
    "comingSoon": "Próximamente habrá más guías sobre análisis, monitorización y configuración de la organización.",
    "noResults": "Ninguna guía coincide con su búsqueda.",
    "featureGuides": {
      "odkServers": {
        "title": "Servidores ODK",
        "summary": "Conecte su servidor ODK Central (o compatible) para que UDACAPI pueda sincronizar proyectos y envíos.",
        "whenToUse": "Configuración inicial, antes de sincronizar o importar.",
        "steps": [
          "Abra Servidores ODK en la barra lateral.",
          "Añada la URL del servidor y las credenciales.",
          "Ejecute Probar conexión.",
          "Corrija URL, credenciales o problemas de red antes de sincronizar."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Obtenga nuevos envíos y actualice la estructura del formulario desde ODK.",
        "whenToUse": "Después de conectar el servidor; cuando espere nuevos datos de campo.",
        "steps": [
          "Abra Sync Workbench.",
          "Seleccione servidor, proyecto y formulario.",
          "Revise el cursor y el estado de la última sincronización.",
          "Inicie la sincronización y espere a que finalice.",
          "Abra el formulario — Overview, Export o QC."
        ]
      },
      "import": {
        "title": "Importar proyectos y formularios",
        "summary": "Traiga proyectos y formularios ODK existentes a su organización.",
        "whenToUse": "Migración desde ODK o incorporación de un nuevo servidor.",
        "steps": [
          "Asegúrese de que el servidor ODK esté conectado y probado.",
          "Desde Proyectos, inicie Importar (solo servidores de la organización).",
          "Seleccione un proyecto e importe formularios.",
          "Abra un formulario y verifique Overview y Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "Workbench de AI para redactar, previsualizar y publicar cambios en XLSForm.",
        "whenToUse": "Nuevas encuestas o cambios importantes en el esquema.",
        "steps": [
          "Abra un proyecto e inicie XLSForm Assist.",
          "Describa la encuesta o suba un archivo de preguntas.",
          "Revise la vista previa de ODK Web Forms.",
          "Confirme la publicación y espere a que finalice el trabajo."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Instantánea de ingesta, línea de tiempo, mapa y preguntas y respuestas con AI para el periodo seleccionado.",
        "whenToUse": "Monitorización diaria; preguntas rápidas sobre datos en vivo del formulario.",
        "steps": [
          "Abra un formulario y vaya a Overview.",
          "Elija el periodo (7 / 30 / all) — compartido por informes AI y la línea de tiempo.",
          "Revise la línea de tiempo y el mapa.",
          "Use el chat AI o genere informes resumidos para la misma ventana."
        ]
      },
      "autoReports": {
        "title": "Informes automáticos",
        "summary": "Informes AI programados y bajo demanda por formulario con entrega por email.",
        "whenToUse": "Actualizaciones periódicas para las partes interesadas (semanal o mensual).",
        "steps": [
          "Org → Plantillas de informes — cree o elija una plantilla.",
          "Formulario → Informes automáticos — configure horario y destinatarios.",
          "Use Generate para una vista previa manual con periodo.",
          "Use Send para entregar después de la vista previa."
        ]
      },
      "qc": {
        "title": "Control de calidad (QC)",
        "summary": "Reglas de validación sobre envíos; la AI puede sugerir un paquete inicial.",
        "whenToUse": "Después de los primeros envíos; antes de confiar en exportaciones o análisis.",
        "steps": [
          "Abra un formulario y vaya a QC.",
          "Cree una regla o use sugerencia AI.",
          "Ejecute la validación.",
          "Revise los envíos marcados."
        ]
      },
      "export": {
        "title": "Exportación de datos",
        "summary": "Exporte envíos a CSV, Excel y más; formularios grandes usan trabajos asíncronos.",
        "whenToUse": "Entrega a Excel, SPSS, Stata o pipelines externos.",
        "steps": [
          "Abra un formulario y vaya a Data Export.",
          "Elija formato y opciones.",
          "Inicie la exportación y espere al trabajo.",
          "Descargue el archivo desde la lista de trabajos."
        ]
      }
    },
    "faq": {
      "title": "Preguntas frecuentes",
      "items": {
        "sync-no-new-data": {
          "question": "¿Por qué la sincronización no obtiene nuevos envíos?",
          "answer": "Compruebe que el servidor ODK sea accesible, que el cursor de sincronización no esté bloqueado en una posición antigua, que haya seleccionado el formulario correcto y que su cuenta tenga acceso a ese proyecto. Ejecute Probar conexión en el servidor y vuelva a intentar la sincronización desde Sync Workbench."
        },
        "sync-cursor": {
          "question": "¿Qué es un cursor de sincronización?",
          "answer": "Un cursor es el puntero de sincronización incremental — dónde UDACAPI dejó de leer envíos por última vez. Restablecer o desalinear cursores puede omitir o volver a obtener datos; use Sync Workbench para inspeccionar el estado del cursor antes de forzar una resincronización completa."
        },
        "import-server-type": {
          "question": "¿Por qué no puedo importar desde este servidor?",
          "answer": "La importación de proyectos solo está permitida en servidores ODK de la organización. Los servidores Shared y Global no pueden usarse para importar — conecte un servidor de la org o consulte a su administrador."
        },
        "import-how": {
          "question": "¿Cómo importo un proyecto ODK existente?",
          "answer": "Conecte y pruebe el servidor, luego vaya a Proyectos → Importar, elija el proyecto e importe formularios. Consulte la guía Importar proyectos y formularios arriba para instrucciones paso a paso."
        },
        "xlsform-where": {
          "question": "¿Dónde está XLSForm Assist?",
          "answer": "Abra un proyecto desde Proyectos, luego inicie XLSForm Assist desde el área de formularios del proyecto (o la ruta dedicada de asistencia de ese proyecto)."
        },
        "ai-scope": {
          "question": "¿Qué puede responder la AI del formulario?",
          "answer": "Preguntas sobre el esquema del formulario, envíos, analítica, reglas QC y estado de sincronización — basadas en datos en vivo de ese formulario. No sustituye la aprobación QC ni la revisión legal de datos personales."
        },
        "ai-quota": {
          "question": "¿Por qué veo cuota excedida?",
          "answer": "Su organización alcanzó un límite de uso del agente. Espere la ventana de restablecimiento o contacte al propietario o administrador de la organización para ajustar los límites."
        },
        "auto-generate-vs-schedule": {
          "question": "¿Cuál es la diferencia entre Generate y un informe programado?",
          "answer": "Generate se ejecuta bajo demanda para el periodo que elija en el formulario. Las ejecuciones programadas siguen el cron de la plantilla y usan la ventana de datos alineada con el horario — no necesariamente la misma que el selector de periodo de Overview."
        },
        "auto-templates": {
          "question": "¿Dónde se gestionan las plantillas de informes?",
          "answer": "A nivel de organización: Mi organización → Plantillas de informes (o el enlace rápido de plantillas). Las plantillas son centrales de la org; la pestaña Informes automáticos de cada formulario muestra las plantillas que cubren ese formulario."
        },
        "qc-first-rule": {
          "question": "¿Cómo creo mi primera regla QC?",
          "answer": "Abra el formulario → QC → Crear regla, o use sugerencia AI para redactar un paquete inicial a partir de la estructura del formulario, luego ejecute la validación."
        },
        "export-slow": {
          "question": "La exportación tarda mucho — ¿es normal?",
          "answer": "Sí, en formularios grandes. Las exportaciones se ejecutan como trabajos en segundo plano. Mantenga la página abierta o vuelva a Data Export para descargar cuando el trabajo finalice."
        },
        "export-where": {
          "question": "¿Dónde está mi archivo exportado?",
          "answer": "En la pestaña Data Export del formulario — en la lista de trabajos/historial con acción de descarga cuando el estado del trabajo es complete."
        },
        "permissions-missing": {
          "question": "No veo un proyecto o una pestaña",
          "answer": "Su grupo de permisos puede no incluir ese proyecto o función. Pida al propietario de la organización que revise los grupos de permisos y el acceso a proyectos."
        }
      }
    },
    "support": {
      "title": "¿Necesita más ayuda?",
      "body": "Contacte con el soporte de UDACAPI si estas guías no resuelven su problema.",
      "contactLabel": "Enviar email al soporte"
    }
  }
}
